import React, { useEffect, useContext, useRef, useState } from "react";
import Button from "./Button";
import { AppContext } from "../context";
import * as tf from "@tensorflow/tfjs";
import {
    PartDetector,
    setBackendExternally,
} from "../partdetection_new/PartDetector";
import { Guidance } from "../guidance_new/GuidanceMain";
import drawArc from "../utils_new/DrawArc";
import drawArcVin from "../utils_new/DrawArcVIN";
import initGreenImg from "../img/coverage_green.png";
import carsmall from "../img/carsmall.png";
import { Check } from "lucide-react";
import { toast } from "react-toastify";
import initRedImg from "../img/coverage_red.png";
import initBlueImg from "../img/coverage_blue.png";
import initBlueImgDot from "../img/coverage_blue_with_dot.PNG";
import indicator from "../img/indicator.svg";
// vin image
import vinLocationCar from "../img/vinLocationCar.png";
import engineVin from "../img/engineVin.svg";
import windshieldVin from "../img/windshieldVin.svg";
import rightFrontDoorVin from "../img/rightFrontDoorVin.svg";
import { IMG360CONFIG } from "../utils_new/Constants";
import underbodyRightFrontWheelVin from "../img/underbodyRightFrontWheelVin.png";
import cameraImg from "../img/camera.png";
import leftVinArrow from "../img/leftVinArrow.gif";
import car_inspection from "../img/vin.png";
import RightVInArrow from "../img/RightVInArrow.gif";
import vinPointingArrow from "../img/vinPointingArrow.svg";
import vinCross from "../img/vin-cross.png";
import vinWindshield from "../img/vin-windshield.png";
import vinDoor from "../img/vin-door.png";
import vinWheel from "../img/vin-wheel.png";
import vinArrow from "../img/vin-arrow.png";
import {
    runCarPartDetection,
    preprocessVideo,
} from "../partdetection_new/NewPartDetector";

// vin images end
import Rotate from "./Rotate";
import {
    addImageToList,
    sendCoveredArea,
    setLog,
    lowLightImage,
    actualRegion,
    userLogs,
    patLogs,
    getModel,
    resumeFlowFinalSubmitHandler,
    setImgCOunt,
    vin_detection,
    translateText,
    getConstraint,
    getAspectRatioClientList,
    getWebpImageFormat,
    getImgQualityFactor,
    setVideoFlag,
    getVideoFlag,
    setGlobalImageQueue,
    setAckoAnyGreyFlag,
    totalImagesUploadStatus,
    setAckoCompletionRedisTag,
    setPortoModuleComplete,
    setAllSideCoveredVideo,
    getRedirectVideoToImgFlag,
    imageFeedbackLambda,
} from "../context/utils";

import * as constants from "../utils_new/Constants";
import arrowDown from "../img/down_arrow.gif";
import arrowUp from "../img/up_arrow.gif";
// import ReactGA from "react-ga4";
let fameInterval;
let logbugs = true;
const screenfull = require("screenfull");
var progressBar = require("progressbar.js");
let flowStop = false;
let processCompleted = false;
let minStop = false;
let processEnd = false;
let notCoveredArea = "";
let showOnce = true;
let regionsAndAnglesMap = {};
for (let val of Object.values(constants.REGIONS))
    regionsAndAnglesMap[val] = new Set();
let allActualRegionDataLog = {};
let allActualRegionDataLogsCheck = {};
let finalRegionsMap = {};
let angleStop = true;
let regionsAngleCountThresh = 1;
let lowLightThreshold = 0.75;
let valuesToCountLowLightImage = [1, 2];
let greenStop = true;
let intervalId;
let intervalId2;
let lumaImageCountThreshold = 5;
let lowLightImageData = [];
let captured = 0;
let allActualRegionData = {};
let actualGuidanceRegion;
let seconds = 0;
let minutes = 0;
let WholeLightLumaData = "";
let data = {};
let track = null;
let angleDetectedGyro = [];
let currentUploadedPartCount = null;
let preRecordingInterval = null;
let detectMlCheck = true;
let stopShowingNudgesDOWN = true;
let stopShowingNudgesUP = true;
let allGreenGlobal = false;
let hiddenRestrictedCard = false;
let imgValue = 0;
let afterFrameimgValue = 0;
let stopRecordingML = false;
let allowImgURLmain = {};
let regionWiseData = {};
let allFrameUpload = false;
let revolutionRegion = "";
let revolutionRegionlist = [];
let logFlag = true;
let upValue = 1;
let errorPrintCount = 0;
let ackoApproveRedisFlag = true;
let readGuide = false;
let stopTimeout = false;
let stopGuidingUser = "showGuiding";
let intervalVin;
let hideRecordbutton = true;
let tempVIN = "";
let onceStop = true;
let froudInterval;
let timeoutVin;

let webCamPromise = null;
let model = null;
let active = true;
let images = [];
let endTimer = 0;
let modalFlag = false;
let startTimer = null;
let isVideoRecordingActive = false; // Prevents preRecordingInterval from running when normal video is active
let allRegionsCovered = false;
let allGreen = false;
let detections = [];
let odometerBgInterval;
let currentGyroRegion = null;
let currentGyroAngle = null;

const IntegratedVideo = () => {
    const {
        stepCovered,
        setStepCovered,
        setScreen,
        currentBlock,
        condition,
        setCondition,
        config,
        token,
        mandatory,
        setMandatory,
        inspectionId,
        setStopPing,
        setCurrentPage,
        stopPing,
        restrictUserIfallNotGreen,
        setRestrictUserIfallNotGreen,
        clientId,
        caseId,
        isIOS,
        setSubCondition,
        subCondition,
        setSubMandatory,
        subMandatory,
        setCurrentBlock
    } = useContext(AppContext);

    const arrowUpText = useRef();
    const arrowDownText = useRef();
    const upArrow = useRef();
    const downArrow = useRef();
    const timerRef = useRef();
    const textRef = useRef();
    const videoRef = useRef();
    const startBtn = useRef();
    const stopBtn = useRef();
    const canvasRef = useRef();
    const canvas1 = useRef();
    const canvas4 = useRef();
    const canvas6 = useRef();
    const canvas7 = useRef();
    const canvas2 = useRef();
    const screen3 = useRef();
    const canvas5 = useRef();
    const reelsRef = useRef();
    const modalRef = useRef();
    const modalImg = useRef();
    const settingsRef = useRef();
    const cardRef = useRef();
    const reviewRef = useRef();
    const warnRef = useRef();
    const backRef = useRef();
    const imgRef = useRef();
    const startRef = useRef();
    const completeRef = useRef();
    const vinModalContainerHeaderRef = useRef();
    const incompleteRef = useRef();
    const completeImgRef = useRef();
    const completeImgRestrictedRef = useRef();
    const stopRef = useRef();
    const timeUpRef = useRef();
    const angleRef = useRef();
    const angleDetailRef = useRef();
    const lowLightRegion = useRef();
    const lowLightRegion2 = useRef();
    const restrictedReviewRef = useRef();
    const incompleteSecoundText = useRef();
    const ackoReviewRef = useRef();
    const modalGuidanceText = useRef();
    const loaderGuidanceText = useRef();
    const skipDiv = useRef();
    const vinGuidePopup = useRef();
    const leftArrowVin = useRef();
    const rightArrowVin = useRef();
    const canvasVIN = useRef();
    const lowerMessagePopup = useRef();
    const lowerMessagePopupP2 = useRef();
    const textRefDiv = useRef();
    const dotCod = useRef();
    const askUserPopup = useRef();
    const vinDetecting = useRef();
    const successMssg = useRef();
    const retryPopupVin = useRef();
    const vinModalContainer = useRef();
    const storedValue = useRef(null);

    const feedBackPopUp = useRef();
    const feedBackPopText = useRef();
    const feedbackBtnRef = useRef();
    const feedbackSuccessTopPopRef = useRef();
    const feedbackSuccessBottomPopRef = useRef();
    const vinInputRef = useRef();
    const crossTickBtn = useRef();
    const headerText1 = useRef();
    const imageRef = useRef();
    const carInspectionRef = useRef();
    // const hRef = useRef();
    // const hRef2 = useRef();
    const partDetector = new PartDetector();
    const guidance = new Guidance(
        config["video-page"]["guidanceMessages"],
        clientId,
        config
    );
    const [disableStopRef, setDisableStopRef] = useState(false);
    const [hiddenStopRef, setStopHiddenRef] = useState(false);
    const [recordStopBtnFlag, setRecordStopBtnFlag] = useState(true);
    const [unCaptureList, setUnCaptureList] = useState([]);
    const [notDetectedFlag, setNotDetectedFlag] = useState(true);
    const [errorType, setErrorType] = useState(false);
    const [vinPosition, setVinPosition] = useState("windshieldVin");
    const [enableVInCanvas, setEnableVInCanvas] = useState(false);
    const [enableVInCanvas2, setEnableVInCanvas2] = useState(false);
    const [vinPositionAngle, setVinPositionAngle] = useState(0);
    // const [stopGuidingUser, setStopGuidingUser] = useState("showGuiding");
    const [vinDetected, setVinDetected] = useState(false);
    const [showVinModal, setShowVinModal] = useState(false);
    const [isCapturingVin, setIsCapturingVin] = useState(true);
    const [showManualCapture, setShowManualCapture] = useState(false);
    const [availableVinLocations, setAvailableVinLocations] = useState([
        "windshieldVin",
        "rightFrontDoorVin",
        "engineVin",
        "underbodyRightFrontWheelVin"
    ]);
    const [skipLambdaNextTime, setSkipLambdaNextTime] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [message, setMessage] = useState("");
    const [feedbackBtnText, setFeedbackBtnText] = useState("");
    const [showOdometerCapture, setShowOdometerCapture] = useState(false);

    let vinCapturedCount = 0;
    let vinEditToastId = null;
    let checkVin = [];

    const imageRetake = () => {
        if (feedBackPopUp.current) feedBackPopUp.current.style.display = "none";
        if (vinDetecting.current) vinDetecting.current.style.display = "flex";
        if (lowerMessagePopup.current) lowerMessagePopup.current.style.display = "flex";

        stopGuidingUser = "detectVin";
        intervalVin = setInterval(() => {
            startCapturingVin();
        }, 1000);
        timeoutVin = setTimeout(() => {
            clearInterval(intervalVin);
            stopGuidingUser = "retryPopup";
            if (retryPopupVin.current) retryPopupVin.current.style.display = "flex";
        }, 10000);
    };

    const imageNext = () => {
        startVideoRecordingMode();
    };

    const handleVinChange = (e) => {
        let value = e.target.value;
        value = value.replace(/[^a-zA-Z0-9]/g, '');
        if (value.length > 17) {
            if (!vinEditToastId || !toast.isActive(vinEditToastId)) {
                vinEditToastId = toast.error(getTranslateText("You can enter up to 17 characters"), {
                    position: "bottom-right",
                    theme: "colored"
                });
            }
            return;
        }
        setMessage(value.toUpperCase());
    };
    const formatVinForDisplay = (rawVin) => {
        return rawVin.toUpperCase();
    };

    useEffect(() => {
        if (isEditing && vinInputRef.current) {
            setTimeout(() => {
                vinInputRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                vinInputRef.current.focus();
            }, 300);
        }
    }, [isEditing]);

    data = {
        text: config["video-page"]["dataText"],
        feedbacks: [],
        regionsCovered: guidance.regionsCoveredMap,
        angle: 0,
        region: "",
        nudges: { partToPoint: "", Nudge: "" },
    };

    const getTranslateText = (text) => {
        if (Object.keys(config["language"]).includes(text)) {
            return config["language"][text];
        } else {
            // const data1 = translateText(text, config["language"]["langCode"]);
            return text;
        }
    };

    const ua = navigator.userAgent.toLowerCase();
    const isAndroid = ua.indexOf("android") > -1;
    const isIos = !!/iPhone|iPad|iPod/i.test(ua);
    const isChrome = !!window.chrome && ua.indexOf("chrome") > -1;
    const isFirefox = ua.indexOf("firefox") > -1;
    const isSafari = /^((?!chrome|android).)*safari/i.test(ua);

    const isLandscape = () => window.innerWidth > window.innerHeight * 1.2;
    if (logbugs) {
        patLogs("Entered to Video module", inspectionId);
        userLogs({ position: 8, last_page: "video module", inspectionId });
        // ReactGA.send({
        //   hitType: "pageview",
        //   page: "Video module",
        //   title: "Video module",
        // });
    }
    logbugs = false;

    const sendLogData = async (data) => {
        userLogs(data);
    };

    const drawProgress = () => {
        let bar = new progressBar.Circle("#progress_loader", {
            strokeWidth: 6,
            easing: "easeInOut",
            duration: 6000,
            color: "#000000",
            trailColor: "#eee",
            trailWidth: 4,
            svgStyle: null,
            step: function (state, circle) {
                let value = Math.round(circle.value() * 100);
                if (value === 0) {
                    circle.setText("");
                } else {
                    circle.setText(`${value}%`);
                }
            },
        });
        return bar;
    };

    const getAllFrameUpload = () => {
        return allFrameUpload;
    };

    const captureImg = (imgURL, detections) => {
        imgValue = imgValue + 1;
        let frameData = guidance.getFramesToPush(
            imgURL,
            detections,
            stopRecordingML
        );
        currentUploadedPartCount = frameData["currentUploadedPartCount"];
        allFrameUpload = frameData["allFrameUpload"];
        //console.log("allFrameUpload", allFrameUpload);
        let frames_to_push = [];
        if (frameData["framesToPush"].length > 1) {
            if (frameData["framesToPush"][1].length > 0) {
                afterFrameimgValue = afterFrameimgValue + 1;
            }
            frames_to_push = frameData["framesToPush"][1];
        }
        let region = Object.keys(config["video-page"]).includes("clientRegion")
            ? config["video-page"]["clientRegion"]
            : "eu-central-1";
        for (let i = 0; i < frames_to_push.length; i++) {
            if (
                frames_to_push[i] &&
                frames_to_push[i].hasOwnProperty("frameEncoded")
            ) {
                let frameEncoded = frames_to_push[i]["frameEncoded"];
                let angle = frames_to_push[i]["angle"];
                let web_region = frames_to_push[i]["region"];
                let videoData = frames_to_push[i];
                delete videoData.frameEncoded;
                if (
                    [
                        "porto_seguros",
                        "porto_seguros_uat",
                        "hc_pilot",
                        "arval_dev",
                    ].includes(clientId)
                ) {
                } else {
                    setNotDetectedFlag(true);
                }
                setGlobalImageQueue({
                    name: `${captured}.jpg`,
                    imgData: frameEncoded,
                    tag: web_region,
                    angle,
                    web_region,
                    env: 1,
                    region: region,
                    videoData: JSON.stringify(frames_to_push[i]),
                    dialStatus: finalRegionsMap,
                });
                addImageToList({
                    name: `${captured}.jpg`,
                    imgData: frameEncoded,
                    tag: web_region,
                    angle,
                    env: 1,
                    web_region,
                    region: region,
                    videoData: JSON.stringify(frames_to_push[i]),
                    dialStatus: finalRegionsMap,
                });
                captured++;
            }
        }
    };

    const detect360 = (data, angleStop, revolutionRegionCurrent) => {
        if (!showOnce) {
            return;
        }
        if (revolutionRegion === "" && revolutionRegionlist.length === 0) {
            revolutionRegion = revolutionRegionCurrent;
            return;
        }
        if (revolutionRegion !== revolutionRegionCurrent) {
            !revolutionRegionlist.includes(revolutionRegion) &&
                revolutionRegionlist.push(revolutionRegion);
            revolutionRegion = revolutionRegionCurrent;
        }
        if (
            revolutionRegionlist.length === 7 &&
            data.regionsCovered[revolutionRegion] === 2
        ) {
            !revolutionRegionlist.includes(revolutionRegionCurrent) &&
                revolutionRegionlist.push(revolutionRegionCurrent);
            revolutionRegion = revolutionRegionCurrent;
        }

        if (revolutionRegionlist.length === 8) {
            angleStop = false;
            const coveredSides = Object.values(data.regionsCovered).filter(
                (value) => value === 0
            ).length;
            if (coveredSides) setRecordStopBtnFlag(false);
            angleRef.current.style.display = "flex";
            if (showOnce) {
                lowLight();
                intervalId = setInterval(() => {
                    lowLight();
                }, 2000);
                Object.keys(data.regionsCovered).map((e) => {
                    if (
                        data.regionsCovered[e] ===
                        constants.REGION_COVERAGE_STATUS.NOT_COVERED ||
                        data.regionsCovered[e] ===
                        constants.REGION_COVERAGE_STATUS.PARTIALLY_COVERED
                    ) {
                        if (Object.keys(config["video-page"]).includes("region")) {
                            notCoveredArea = ` ${config["video-page"]["region"][e]}, ${notCoveredArea}`;
                        } else {
                            notCoveredArea = ` ${e}, ${notCoveredArea}`;
                        }
                    }
                });

                showOnce = false;
                if (notCoveredArea.endsWith(", ")) {
                    notCoveredArea = notCoveredArea.slice(0, -2);
                }
                if (["porto_seguros", "porto_seguros_uat"].includes(clientId))
                    setUnCaptureList(notCoveredArea.split(", "));
                else angleDetailRef.current.innerHTML = notCoveredArea;
                drawArc(canvas4.current, data.angle, data.regionsCovered, clientId);
                patLogs("One revolution of car is completed", inspectionId);
            }
        }
    };

    const captureImgFrame = (byPassBlack) => {
        try {
            const cnv = canvasRef.current;
            const vw = videoRef.current;

            // Check if refs exist
            if (!cnv || !vw) {
                console.log("Canvas or video ref is null");
                return false;
            }

            // Check if video metadata is loaded
            if (vw.videoWidth === 0 || vw.videoHeight === 0) {
                console.log("Video not ready yet");
                return false;
            }

            cnv.width = vw.videoWidth;
            cnv.height = vw.videoHeight;
            const ctx = cnv.getContext("2d");
            ctx.drawImage(vw, 0, 0);
            const imageData = ctx.getImageData(0, 0, cnv.width, cnv.height);
            const { data, width, height } = imageData;
            let blackPixelCount = 0;
            for (let i = 0; i < data.length; i += 4) {
                const [r, g, b] = [data[i], data[i + 1], data[i + 2]];
                const brightness = (r + g + b) / 3;
                if (brightness < 5) {
                    blackPixelCount++;
                }
            }
            const totalPixels = width * height;
            const blackPercentage = (blackPixelCount / totalPixels) * 100;
            return byPassBlack
                ? getWebpImageFormat() && !isIOS
                    ? cnv.toDataURL("image/webp", getImgQualityFactor())
                    : cnv.toDataURL("image/jpeg")
                : blackPercentage < 98
                    ? getWebpImageFormat() && !isIOS
                        ? cnv.toDataURL("image/webp", getImgQualityFactor())
                        : cnv.toDataURL("image/jpeg")
                    : false;

        } catch (err) {
            console.log("faces error in newVideo captureImgFrame method : ", err);
            return false;
        }
    };

    // vin code
    const FraudImageUpload = () => {
        let img = captureImgFrame(true);
        let region = Object.keys(config["video-page"]).includes("clientRegion")
            ? config["video-page"]["clientRegion"]
            : "eu";
        region = region === "eu" ? "eu-central-1" : "ap-south-1";
        setGlobalImageQueue({
            name: `FroudDetection.jpg`,
            imgData: img,
            tag: "FroudDetection",
            web_region: null,
            angle: null,
            env: 1,
            region: region,
            videoData: null,
            dialStatus: null,
        });
        addImageToList({
            name: `FroudDetection.jpg`,
            imgData: img,
            tag: "FroudDetection",
            web_region: null,
            angle: null,
            env: 1,
            region: region,
            videoData: null,
            dialStatus: null,
        });
    };
    const calculateUserPositions = (variable, constant) => {
        const vinRegion = [
            "Front",
            "Front-Isometric-Left",
            "Side-Left",
            "Rear-Isometric-Left",
            "Rear",
            "Rear-Isometric-Right",
            "Side-Right",
            "Front-Isometric-Right",
            "Front",
        ];
        const variableIndex = vinRegion.indexOf(variable);
        const constantIndex = vinRegion.indexOf(constant);
        // Validate if both values exist in the array
        if (variableIndex === -1 || constantIndex === -1) {
            console.log("Invalid variable or constant value", variable, constant);
            return "undefined";
        }
        const totalRegions = vinRegion.length;
        // Calculate clockwise and counterclockwise distances considering circular nature
        const clockwiseDistance =
            (constantIndex - variableIndex + totalRegions) % totalRegions;
        const counterClockwiseDistance =
            (variableIndex - constantIndex + totalRegions) % totalRegions;
        // for same position
        if (clockwiseDistance === 0 || counterClockwiseDistance === 0) {
            return "same";
        }
        // move from right
        if (clockwiseDistance < counterClockwiseDistance) {
            return "left";
            // move from left
        } else if (counterClockwiseDistance < clockwiseDistance) {
            return "right";
            // can move from left or right, but choose to return "right"
        } else {
            return "left";
        }
    };
    const calculateCord = (detections, vinPosition) => {
        console.log("etections, vinPosition", detections, vinPosition);
        let scaleX = window.innerWidth / 128;
        let scaleY = window.innerHeight / 128;
        let part =
            vinPosition === "engineVin"
                ? "hood"
                : vinPosition === "windshieldVin"
                    ? "front_glass"
                    : vinPosition === "rightFrontDoorVin"
                        ? "front_door"
                        : vinPosition === "underbodyRightFrontWheelVin"
                            ? "fender"
                            : "";
        dotCod.current.style.display = "none";
        if (Array.isArray(detections) && detections.length > 0) {
            detections.forEach((detection) => {
                if (detection.label === part) {
                    let [x, y, width, height] = detection.bbox;
                    let centerX_128 = 0;
                    let centerY_128 = 0;
                    switch (vinPosition) {
                        case "engineVin":
                            centerX_128 = x + width / 2;
                            centerY_128 = y + height;
                            break;
                        case "windshieldVin":
                            centerX_128 = x + width * 0.9;
                            centerY_128 = y + height * 0.9;
                            break;
                        case "rightFrontDoorVin":
                            centerX_128 = x;
                            centerY_128 = y;
                            break;
                        case "underbodyRightFrontWheelVin":
                            centerX_128 = x + width / 2;
                            centerY_128 = y + height / 3;
                            // centerY_128 = y + height / 3;
                            break;
                        default:
                            centerX_128 = 0;
                            centerY_128 = 0;
                            dotCod.current.style.display = "none";
                            break;
                    }
                    let Xcod = centerX_128 * scaleX * 128;
                    let Ycod = centerY_128 * scaleY * 128;
                    console.log(centerX_128, centerY_128);
                    dotCod.current.style.display = "flex";
                    dotCod.current.style.top = `${Ycod.toFixed(2) - 50}px`;
                    dotCod.current.style.left = `${Xcod.toFixed(2) - 160}px`;
                }
            });
        }
    };
    const updateVinDataUI = (
        variableRegion,
        angle,
        regionsCovered,
        canvasVIN,
        detections
    ) => {
        console.log(variableRegion, angle, regionsCovered, canvasVIN, detections);
        hideRecordbutton = false;
        let regionAccordingVin =
            tempVIN === "engineVin"
                ? "Front"
                : tempVIN === "windshieldVin"
                    ? "Front"
                    : tempVIN === "rightFrontDoorVin"
                        ? "Side-Right"
                        : tempVIN === "underbodyRightFrontWheelVin"
                            ? "Front-Isometric-Right"
                            : false;
        if (stopGuidingUser === "showGuiding") {
            const val = calculateUserPositions(variableRegion, regionAccordingVin);
            if (leftArrowVin.current) leftArrowVin.current.style.display = "none";
            if (rightArrowVin.current) rightArrowVin.current.style.display = "none";
            switch (val) {
                case "right":
                    if (leftArrowVin.current) leftArrowVin.current.style.display = "flex";
                    if (dotCod.current) dotCod.current.style.display = "none";
                    lowerMessagePopup.current.style.display = "flex";
                    break;
                case "left":
                    if (rightArrowVin.current)
                        rightArrowVin.current.style.display = "flex";
                    if (dotCod.current) dotCod.current.style.display = "none";
                    lowerMessagePopup.current.style.display = "flex";
                    break;
                case "same":
                    !stopTimeout &&
                        setTimeout(() => {
                            stopGuidingUser = "askUserVin";
                        }, 5000);
                    stopTimeout = true;
                    calculateCord(detections, tempVIN);
                    if (leftArrowVin.current) leftArrowVin.current.style.display = "none";
                    if (rightArrowVin.current)
                        rightArrowVin.current.style.display = "none";
                    lowerMessagePopup.current.style.display = "flex";
                    break;
                default:
                    if (dotCod.current) dotCod.current.style.display = "none";
                    if (lowerMessagePopup.current)
                        lowerMessagePopup.current.style.display = "none";
                    break;
            }
        } else if (stopGuidingUser === "askUserVin") {
            calculateCord(detections, tempVIN);
            if (leftArrowVin.current) leftArrowVin.current.style.display = "none";
            if (rightArrowVin.current) rightArrowVin.current.style.display = "none";
            if (lowerMessagePopup.current)
                lowerMessagePopup.current.style.display = "none";
            askUserPopup.current.style.display = "flex";
        } else if (stopGuidingUser === "detectVin") {
            if (dotCod.current) dotCod.current.style.display = "none";
            if (askUserPopup.current) askUserPopup.current.style.display = "none";
            if (leftArrowVin.current) leftArrowVin.current.style.display = "none";
            if (rightArrowVin.current) rightArrowVin.current.style.display = "none";
            if (retryPopupVin.current) retryPopupVin.current.style.display = "none";
            if (vinDetecting.current) vinDetecting.current.style.display = "flex";
            if (lowerMessagePopup.current)
                lowerMessagePopup.current.style.display = "flex";
        } else if (stopGuidingUser === "retryPopup") {
            if (vinDetecting.current) vinDetecting.current.style.display = "none";
            if (lowerMessagePopup.current)
                lowerMessagePopup.current.style.display = "none";
        } else if (stopGuidingUser === "detectedVin") {
            if (retryPopupVin.current) retryPopupVin.current.style.display = "none";
            if (vinDetecting.current) vinDetecting.current.style.display = "none";
            if (lowerMessagePopup.current)
                lowerMessagePopup.current.style.display = "none";
            if (retryPopupVin.current) retryPopupVin.current.style.display = "none";
        } else if (stopGuidingUser === "differentLocation") {
            if (dotCod.current) dotCod.current.style.display = "none";
            if (askUserPopup.current) askUserPopup.current.style.display = "none";
        }

        drawArcVin(
            canvasVIN,
            angle,
            regionsCovered,
            regionAccordingVin,
            variableRegion
        );
    };
    const startCapturingVin = async () => {
        let img = captureImgFrame(false);
        let region = Object.keys(config["video-page"]).includes("clientRegion")
            ? config["video-page"]["clientRegion"]
            : "eu-central-1";
        if (img) {
            let value = await vin_detection({
                image: getWebpImageFormat() && !isIOS ? img.replace(/^data:image\/webp;base64,/, "") : img.replace(/^data:image\/jpeg;base64,/, ""),
                region: region === "eu-central-1" ? "eu-central-1" : "ap-south-1",
            });
            if (value) {
                clearTimeout(startCapturingVin);
                setGlobalImageQueue({
                    name: `VIN.jpg`,
                    imgData: img,
                    tag: "VIN",
                    web_region: null,
                    env: 1,
                    angle: null,
                    region: region,
                    videoData: null,
                    dialStatus: null,
                });
                addImageToList({
                    name: `VIN.jpg`,
                    imgData: img,
                    tag: "VIN",
                    web_region: null,
                    env: 1,
                    angle: null,
                    region: region,
                    videoData: null,
                    dialStatus: null,
                });
                clearInterval(intervalVin);
                stopGuidingUser = "detectedVin";
                setVinDetected(true);
                if (vinDetecting.current) vinDetecting.current.style.display = "none";

                setMessage("");
                if (feedBackPopUp.current) feedBackPopUp.current.style.display = "none";
                if (feedbackSuccessTopPopRef.current) feedbackSuccessTopPopRef.current.style.display = "flex";
                if (feedbackSuccessBottomPopRef.current) feedbackSuccessBottomPopRef.current.style.display = "flex";
                setFeedbackBtnText(getTranslateText("Proceed"));

                if (!(Object.keys(config).includes("allowVinFeedbackEdit") && config["allowVinFeedbackEdit"])) {
                    setTimeout(() => {
                        if (feedbackSuccessTopPopRef.current) feedbackSuccessTopPopRef.current.style.display = "none";
                        if (feedbackSuccessBottomPopRef.current) feedbackSuccessBottomPopRef.current.style.display = "none";
                        setTimeout(() => {
                            startVideoRecordingMode();
                        }, 1000);
                    }, 4000);
                }
            }
        }
    };
    // vin code end

    const detectFrame = async (video, model) => {
        if (!videoRef || !videoRef.current) return;
        // console.log(active);
        if (
            Object.values(data.regionsCovered).every((val) => val !== 0) &&
            ["porto_seguros", "porto_seguros_uat", "hc_pilot", "arval_dev"].includes(
                clientId,
            )
        ) {
            setAllSideCoveredVideo(true);
            setNotDetectedFlag(true);
        } else {
            ["porto_seguros", "porto_seguros_uat", "hc_pilot", "arval_dev"].includes(
                clientId,
            ) && setNotDetectedFlag(false);
        }
        // if (!guidance.pausePartCoveringAndFrameUpload) {
        let detections = [];
        let newImgURL = captureImgFrame(false);
        if (newImgURL) {
            tf.engine().startScope();

            const processedFrame = partDetector.processInput(video);
            // console.log("processedFrame", processedFrame);
            if (allRegionsCovered) {
                // guidance.pausePartCoveringAndFrameUpload = true;
            } else if (minutes === 7) {
                // guidance.pausePartCoveringAndFrameUpload = true;
            } else if (
                angleRef.current.style.display === "flex" ||
                stopRef.current.style.display === "flex"
            ) {
                // guidance.pausePartCoveringAndFrameUpload = true;
            } else if (
                angleRef.current.style.display === "none" ||
                stopRef.current.style.display === "none"
            ) {
                guidance.pausePartCoveringAndFrameUpload = false;
            }

            //add logs
            if (detectMlCheck) {
                detectMlCheck = false;
                //cardRef.current.style.display = "none";
                patLogs("part_detection_is_working", inspectionId);
            }
            try {
                const predictions = await model.executeAsync(processedFrame);
                const detections = partDetector.getDetectionObjects(predictions);

                let [
                    currentAngle,
                    currentRegion,
                    regionsCoveredMap,
                    feedbacks,
                    videoFreezeStatus,
                    currentNudge,
                    imgURL,
                    allowImgURL,
                    frameCountPerRegion,
                    revolutionRegionCurrent,
                    realGyroAngle,
                    angleRF,
                ] = guidance.performChecksAndGetWarningMessage(
                    detections,
                    processedFrame,
                    newImgURL
                );
                // console.log("cor", cor);
                allRegionsCovered = guidance.checkIfAllRegionsCovered();
                finalRegionsMap = regionsCoveredMap;
                allowImgURLmain = allowImgURL;
                regionWiseData = frameCountPerRegion;

                currentGyroRegion = currentRegion;
                currentGyroAngle = currentAngle;

                const logStatus = Object.values(finalRegionsMap).filter(
                    (value) => value === 1 || value === 2,
                ).length;
                if (logStatus > 0 && logFlag) {
                    patLogs("vehicle_part_detected", inspectionId);
                    logFlag = false;
                }

                if (stopRecordingML && readGuide) {
                    updateVinDataUI(
                        currentRegion,
                        currentAngle,
                        storedValue.current,
                        canvasVIN.current,
                        detections
                    );
                } else {
                    if (canvas1.current) {
                        drawArc(canvas1.current, data.angle, data.regionsCovered, clientId);
                    }
                    if (
                        data.regionsCovered !== null &&
                        typeof data.regionsCovered === "object" &&
                        !Array.isArray(data.regionsCovered) &&
                        Object.keys(data.regionsCovered).length > 0 &&
                        readGuide
                    ) {
                        drawArc(canvas1.current, data.angle, data.regionsCovered, clientId);
                    }
                    if (Object.keys(config["video-page"]).includes("videoNudges")) {
                        if (currentNudge["Nudge"] === "UP") {
                            upArrow.current.style.display = "flex";
                            arrowUpText.current.innerHTML = Object.keys(
                                config["video-page"]["videoNudges"]
                            ).includes(currentNudge["partToPoint"].trim())
                                ? config["video-page"]["videoNudges"][
                                currentNudge["partToPoint"].trim()
                                ]
                                : getTranslateText(currentNudge["partToPoint"]);
                            if (stopShowingNudgesUP) {
                                setTimeout(() => {
                                    upArrow.current.style.display = "none";
                                    stopShowingNudgesUP = true;
                                }, 2000);
                            }
                            stopShowingNudgesUP = false;
                        } else if (currentNudge["Nudge"] === "DOWN") {
                            downArrow.current.style.display = "flex";
                            arrowDownText.current.innerHTML = Object.keys(
                                config["video-page"]["videoNudges"]
                            ).includes(currentNudge["partToPoint"].trim())
                                ? config["video-page"]["videoNudges"][
                                currentNudge["partToPoint"].trim()
                                ]
                                : getTranslateText(currentNudge["partToPoint"]);
                            if (stopShowingNudgesDOWN) {
                                setTimeout(() => {
                                    downArrow.current.style.display = "none";
                                    stopShowingNudgesDOWN = true;
                                }, 2000);
                            }
                            stopShowingNudgesDOWN = false;
                        }
                    }

                    detect360(data, angleStop, revolutionRegionCurrent);
                }
                if (imgURL) {
                    captureImg(imgURL, detections);
                } else if (stopRecordingML) {
                    captureImg(null, null);
                }
                data = {
                    text: feedbacks[feedbacks.length - 1],
                    feedbacks: feedbacks,
                    regionsCovered: regionsCoveredMap,
                    angle: currentAngle !== -1 ? currentAngle : data.angle,
                    region: currentRegion,
                    nudges: currentNudge,
                };
                actualGuidanceRegion = guidance.actualPartsCoveredMap;
                // Prepare region logs
                // Object.keys(actualGuidanceRegion).map((e) => {
                //     allActualRegionDataLog.key = e;
                //     let takeOutValue = [];
                //     actualGuidanceRegion[e].forEach((i) => {
                //         takeOutValue.push(i);
                //     });
                //     allActualRegionDataLog[e] = takeOutValue;
                // });
                Object.keys(actualGuidanceRegion).forEach((e) => {
                    allActualRegionDataLog.key = e;
                    allActualRegionDataLog[e] = [...actualGuidanceRegion[e]];
                });

                if (!angleDetectedGyro.includes(currentAngle)) {
                    angleDetectedGyro.push(currentAngle !== -1 ? currentAngle : 0);
                }

                if (
                    JSON.stringify(allActualRegionDataLog) !==
                    JSON.stringify(allActualRegionDataLogsCheck)
                ) {
                    allActualRegionDataLog["VideoTimer"] = `${minutes} : ${seconds}`;
                    allActualRegionDataLog["angleDetected"] = angleDetectedGyro;
                    allActualRegionDataLog["DialStatus"] = finalRegionsMap;
                    sendCoveredArea(
                        allGreen,
                        allActualRegionDataLog["DialStatus"],
                        clientId,
                        caseId,
                        inspectionId
                    );
                    userLogs({
                        position: 3,
                        video_data: JSON.stringify(allActualRegionDataLog),
                        inspectionId,
                    });
                    allActualRegionDataLogsCheck = { ...allActualRegionDataLog };

                    if (allRegionsCovered) {
                        angleStop = false;
                        angleRef.current.style.display = "none";
                        setTimeout(() => {
                            if (flowStop) return;
                            if (minStop) return;
                            // document.getElementById("window-arc2").style.display = "none"
                            if (greenStop) {
                                lowLightImageData = [];
                                stopRef.current.style.display = "flex";
                                lowLight();
                                drawArc(
                                    canvas5.current,
                                    data.angle,
                                    data.regionsCovered,
                                    clientId
                                );
                                intervalId2 = setInterval(() => {
                                    lowLight();
                                }, 2000);
                            }
                            greenStop = false;
                            allGreen = true;
                            allGreenGlobal = true;
                            hiddenRestrictedCard = true;
                            // guidance.pausePartCoveringAndFrameUpload = true;
                        }, 3000);
                    }
                }
                if (active) requestAnimationFrame(() => detectFrame(video, model));
            } catch (err) {
                // Redirect point

                if (getRedirectVideoToImgFlag()) {
                    patLogs(
                        `Error from detect Frame ${err.message} ,${err.stack}`,
                        inspectionId,
                    );
                    setErrorType(true);
                    //skipDiv.current.style.display = "flex";
                }
                let backendErrorPatterns = [
                    /gl.*lost/i,
                    /webgl.*context/i,
                    /compile.*shader/i,
                    /link.*shader/i,
                    /link.*program/i,
                    /vertex.*shader/i,
                    /fragment.*shader/i,
                    /failed.*shader/i,
                    /webgl.*error/i,
                    /webgpu/i,
                    /device.*lost/i,
                    /cannot.*create.*gpu/i,
                    /gpu.*error/i,
                    /wasm.*memory.*error/i,
                    /memory.*access/i,
                    /invalid.*memory/i,
                    /cpu.*execution.*failed/i,
                    /backend.*error/i,
                    /backend.*failure/i,
                    /tensor.*backend.*error/i,
                    /unexpected.*backend/i,
                ];
                console.log("Model execution failed:", err.message, err.stack);
                console.log("tf.engine().backendName", tf.engine().backendName);
                if (errorPrintCount < 2) {
                    patLogs(`Model execution failed: ${err}`, inspectionId);
                    ++errorPrintCount;
                }
                if (backendErrorPatterns.some((regex) => regex.test(err.message))) {
                    const fallbackBackend =
                        tf.engine().backendName === "webgl" ? "webgpu" : "cpu";
                    const datas = await setBackendExternally(fallbackBackend);
                    if (datas) {
                        if (active)
                            requestAnimationFrame(() => detectFrame(video, model));
                        !Object.keys(config).includes("int8Model") && tf.engine().endScope();
                    }
                } else {
                    if (active) requestAnimationFrame(() => detectFrame(video, model));
                    !Object.keys(config).includes("int8Model") && tf.engine().endScope();
                }
            }
        } else {
            if (active) requestAnimationFrame(() => detectFrame(video, model));
        }
    };

    const lowLightCalculation = (data) => {
        Object.keys(data).forEach((key) => {
            if (data[key].length > lumaImageCountThreshold) {
                const countOccurrences = (arr, value) =>
                    arr.filter((element) => element === value).length;
                const lowLightData = valuesToCountLowLightImage
                    .map((value) => countOccurrences(data[key], value))
                    .reduce((accumulator, currentValue) => accumulator + currentValue, 0);
                if (lowLightData / data[key].length > lowLightThreshold) {
                    if (Object.keys(config["video-page"]).includes("region")) {
                        if (Object.keys(config["video-page"]["region"]).includes(key)) {
                            !lowLightImageData.includes(
                                config["video-page"]["region"][key]
                            ) &&
                                lowLightImageData.push(
                                    `${config["video-page"]["region"][key]}`
                                );
                        } else {
                            !lowLightImageData.includes(key) &&
                                lowLightImageData.push(`${key}`);
                        }
                    } else {
                        !lowLightImageData.includes(key) &&
                            lowLightImageData.push(`${key}`);
                    }
                }
            }
        });
        return lowLightImageData;
    };

    const lowLight = async () => {
        // hRef.current.style.display = "none";
        // hRef2.current.style.display = "none";
        let region = "";
        let data = await lowLightImage();
        WholeLightLumaData = data;
        let value = lowLightCalculation(data);
        if (value.length > 0) {
            value.map((e) => {
                region = `${e}, ${region}`;
            });
            region.endsWith(", ") && (region = region.slice(0, -2));
            // console.log(region, typeof region)
            // region = region + JSON.stringify(data)
            // hRef.current.style.display = "block"
            // hRef2.current.style.display = "block"
            // lowLightRegion.current.innerHTML = region
            // lowLightRegion2.current.innerHTML = region
        } else {
            // region = region + JSON.stringify(data)
            // lowLightRegion.current.innerHTML = region
            // lowLightRegion2.current.innerHTML = region
            // hRef.current.style.display = "none";
            // hRef2.current.style.display = "none";
        }
    };

    const updateUI = () => {
        if (textRef.current) {
            textRef.current.style.display = "block";
            textRef.current.innerHTML =
                data.text && data.text !== config["video-page"]["dataText"]
                    ? data.text
                    : "<span>&nbsp;&nbsp;</span>";
        }

        if (!isLandscape()) {
            if (warnRef.current) warnRef.current.style.display = "flex";
        } else {
            if (warnRef.current) warnRef.current.style.display = "none";
        }
        if (seconds >= 60) {
            minutes++;
            seconds = 0;
        }
        if (seconds < 10) {
            if (timerRef.current) timerRef.current.innerText = "0" + minutes + ":" + "0" + seconds;
        } else {
            if (timerRef.current) timerRef.current.innerText = "0" + minutes + ":" + seconds;
        }

        timerRef.current.style.fontSize = "larger";
        timerRef.current.style.color = "white";
        timerRef.current.style.marginTop = "40px";
        timerRef.current.style.backgroundColor = "rgba(0,0,0,.7)";
        if (data.videoFreezeStatus) {
            // active = false;
            modalFlag = true;
            drawArc(canvas2.current, data.angle, data.regionsCovered, clientId);
        }
        drawArc(canvas6.current, data.angle, data.regionsCovered, clientId);
        drawArc(canvas7.current, data.angle, data.regionsCovered, clientId);
    };

    const reShoot = () => {
        startCamera();
    };

    const continueShoot = () => {
        modalFlag = false;
        active = true;
        detectFrame(videoRef.current, model);
    };

    const startCamera = () => {
        angleRef.current.style.display = "none";
        timeUpRef.current.style.display = "none";
        document.getElementById("window-arc2").style.visibility = "hidden";
        document.getElementById("btn-car-container").style.visibility = "hidden";
        cardRef.current.style.display = "none";
        if (!Object.keys(config).includes("directModule")) {
            backRef.current.style.display = "none";
        }
        startRef.current.style.display = "none";
        if (textRef.current) {
            textRef.current.style.display = "none";
        }
        reviewRef.current.style.display = "none";
        ackoReviewRef.current.style.display = "none";
        restrictedReviewRef.current.style.display = "none";
        warnRef.current.style.display = "none";
        imgRef.current.style.display = "block";
        stopRef.current.style.display = "none";
        modalGuidanceText.current.innerHTML = config["video-page"]["dataText"];
        loaderGuidanceText.current.innerHTML = config["video-page"]["loadingText"];
        if (!stopRecordingML) {
            drawArc(canvas1.current, data.angle, data.regionsCovered, clientId);
        }
        webCamPromise = navigator.mediaDevices
            .getUserMedia(getConstraint(config, clientId))
            .then((stream) => {
                window.stream = stream;
                track = stream.getTracks()[0];
                videoRef.current.srcObject = stream;
                //////////startBtn.current.style.display = "block";
                if (!Object.keys(config).includes("directModule")) {
                    backRef.current.style.display = "block";
                }
                // if (textRef.current) {
                //     textRef.current.style.display = "block";
                // }
                //// document.getElementById("btn-car-container").style.visibility = "visible";
                ///// document.getElementById("window-arc2").style.visibility = "visible";
                settingsRef.current.style.display = "none";
                vinModalContainer.current.style.display = "flex";
                vinModalContainerHeaderRef.current.innerHTML = getTranslateText("Select where your VIN is located to capture it");
                /////startRef.current.style.display = "flex";
                return new Promise(
                    (resolve, _) => (videoRef.current.onloadedmetadata = () => resolve())
                );
            })
            .catch((err) => {
                console.error(err);
            });
    };


    const startVideoRecordingMode = () => {
        if (isVideoRecordingActive) return;

        if (preRecordingInterval) {
            clearInterval(preRecordingInterval);
        }
        preRecordingInterval = setInterval(() => {
            if (isVideoRecordingActive) {
                if (preRecordingInterval) clearInterval(preRecordingInterval);
                return;
            }
            let img = captureImgFrame(false);
            if (img && !isVideoRecordingActive) {
                let region = Object.keys(config["video-page"]).includes("clientRegion")
                    ? config["video-page"]["clientRegion"]
                    : "eu-central-1";
                setGlobalImageQueue({
                    name: `${captured}.jpg`,
                    imgData: img,
                    tag: !isVideoRecordingActive? "VIN_intremin" : "Front",
                    angle: null,
                    web_region: null,
                    env: 1,
                    region: region,
                    videoData: null,
                    dialStatus: null,
                });
                addImageToList({
                    name: `${captured}.jpg`,
                    imgData: img,
                    tag: !isVideoRecordingActive? "VIN_intremin" : "Front",
                    angle: null,
                    web_region: null,
                    env: 1,
                    region: region,
                    videoData: null,
                    dialStatus: null,
                });
                captured++;
            }
        }, 2000);

        angleRef.current.style.display = "none";
        timeUpRef.current.style.display = "none";
        document.getElementById("window-arc2").style.visibility = "hidden";
        document.getElementById("btn-car-container").style.visibility = "hidden";
        cardRef.current.style.display = "none";
        if (!Object.keys(config).includes("directModule")) {
            backRef.current.style.display = "none";
        }
        startRef.current.style.display = "none";
        if (textRef.current) {
            textRef.current.style.display = "none";
        }
        reviewRef.current.style.display = "none";
        ackoReviewRef.current.style.display = "none";
        restrictedReviewRef.current.style.display = "none";
        warnRef.current.style.display = "none";
        imgRef.current.style.display = "block";
        stopRef.current.style.display = "none";
        modalGuidanceText.current.innerHTML = config["video-page"]["dataText"];
        loaderGuidanceText.current.innerHTML = config["video-page"]["loadingText"];
        if (!stopRecordingML) {
            drawArc(canvas1.current, data.angle, data.regionsCovered, clientId);
        }
        startBtn.current.style.display = "block";
        if (textRef.current) {
            textRef.current.style.display = "block";
        }
        document.getElementById("btn-car-container").style.visibility = "visible";
        document.getElementById("window-arc2").style.visibility = "visible";
        settingsRef.current.style.display = "none";
        startRef.current.style.display = "flex";

        if (feedbackSuccessTopPopRef.current) feedbackSuccessTopPopRef.current.style.display = "none";
        if (feedbackSuccessBottomPopRef.current) feedbackSuccessBottomPopRef.current.style.display = "none";
        if (vinModalContainer.current) vinModalContainer.current.style.display = "none";
        if (vinDetecting.current) vinDetecting.current.style.display = "none";
        if (lowerMessagePopup.current) lowerMessagePopup.current.style.display = "none";
    };

    const checkForRedirect = () => {
        if (getRedirectVideoToImgFlag()) {
            setTimeout(() => {
                let b = angleDetectedGyro.filter((num) => num !== 0);
                if (
                    errorType !== true &&
                    Object.values(data.regionsCovered).every((val) => val === 0)
                ) {
                    setErrorType(false);
                    //skipDiv.current.style.display = "flex";
                    patLogs("No detection happen", inspectionId);
                } else if (
                    errorType !== true &&
                    Object.values(data.regionsCovered).some(
                        (val) => val === 1 || val === 2,
                    ) &&
                    b.length < 5
                ) {
                    patLogs(
                        "detection happen but gyro value is not comming",
                        inspectionId,
                    );
                    setErrorType(false);
                    //skipDiv.current.style.display = "flex";
                }
            }, 45000);
        }
    };

    const startRecording = () => {
        isVideoRecordingActive = true;

        if (preRecordingInterval) {
            clearInterval(preRecordingInterval);
            preRecordingInterval = null;
        }
        // Redirect point
        checkForRedirect();
        patLogs("camera button clicked", inspectionId);
        cardRef.current.style.display = "flex";
        if (textRef.current) {
            textRef.current.style.display = "none";
        }
        sendLogData({ position: 9, record_button: "yes", inspectionId });
        if (isIos || isSafari) DeviceMotionEvent.requestPermission();
        startBtn.current.style.display = "none";
        startRef.current.style.display = "none";
        if (!Object.keys(config).includes("directModule")) {
            backRef.current.style.display = "none";
        }
        cardRef.current.style.display = "flex";
        stopRef.current.style.display = "none";
        if (
            Object.keys(config).includes("directModule") &&
            config["directModule"]
        ) {
            drawProgress().animate(0.9);
        }
        settingsRef.current.style.display = "none";
        timerRef.current.style.width = "10%";
        timerRef.current.style.marginLeft = "45%";
        Promise.all([getModel(), webCamPromise])
            .then((values) => {
                sendLogData({
                    position: 6,
                    model_initialized: "yes",
                    inspectionId,
                });
                model = values[0];
                detectFrame(videoRef.current, values[0]);
                // stopBtn.current.style.display = "block";
                startTimer = setInterval(() => {
                    try {
                        cardRef.current.style.display = "none";
                    } catch (err) { }
                    setDisableStopRef(true);
                    if (hiddenStopRef) {
                        if (stopBtn.current) {
                            stopBtn.current.style.display = "none";
                        }
                    } else {
                        if (stopBtn.current && onceStop) {
                            stopBtn.current.style.display = "block";
                        }
                    }
                    seconds++;
                    endTimer++;
                    if (getRedirectVideoToImgFlag() && active)
                        requestAnimationFrame(() => updateUI());
                    else if (!Object.keys(config).includes("getRedirectImage"))
                        requestAnimationFrame(() => updateUI());
                }, 1000);
                setCurrentPage("Model initialize");
                setTimeout(async () => {
                    let flag = Object.values(data.regionsCovered).every(
                        (val) => val === 0,
                    );
                    if (flag) {
                        patLogs("dial_movement_error", inspectionId);
                    }
                }, 20000);
            })
            .catch((error) => {
                console.log(error);
                // Redirect point
                if (getRedirectVideoToImgFlag()) {
                    patLogs(`Model realted problem ${error.message}`, inspectionId);
                    setErrorType(true);
                    //skipDiv.current.style.display = "flex";
                }
                sendLogData({
                    position: 6,
                    model_initialized: `no - ${error.message}`,
                    inspectionId,
                });
                setCurrentPage("Model not initialize");
            });
    };

    const sendMessageAcko = () => {
        if (allGreen) {
            console.log("All Cover: 100%");
            if (clientId !== "autogroup")
                window.top.postMessage("All Cover: 100%", "*");
        } else {
            const totalSides = Object.keys(finalRegionsMap).length;
            const coveredSides = Object.values(finalRegionsMap).filter(
                (value) => value === 1 || value === 2,
            ).length;

            let percentage = (coveredSides / totalSides) * 100;
            percentage = Math.round(percentage);
            console.log("Partial Cover: ", percentage + "%");
            if (clientId !== "autogroup")
                window.top.postMessage(`Partial Cover: ${percentage}%`, "*");
        }
    };

    const stopRecording = (clicked, submitFlag) => {
        if (
            Object.values(data.regionsCovered).every((val) => val === 0) &&
            ["client_1381_prod", "client_1381"].includes(clientId)
        ) {
            setNotDetectedFlag(false);
            ackoReviewRef.current.style.display = "flex";
            return;
        } else {
            setNotDetectedFlag(true);
        }

        if (
            ["hc_pilot", "porto_seguros", "porto_seguros_uat", "arval_dev"].includes(
                clientId,
            ) &&
            Object.values(data.regionsCovered).some((val) => val === 0)
        ) {
            setNotDetectedFlag(false);
            ackoReviewRef.current.style.display = "flex";
            return;
        }

        if (storedValue.current === null) {
            storedValue.current = { ...finalRegionsMap }; // Store only once
        }

        sendCoveredArea(allGreen, finalRegionsMap, clientId, caseId, inspectionId);
        if (!typeof actualGuidanceRegion === "undefined") {
            Object.keys(actualGuidanceRegion).map((e) => {
                allActualRegionData.key = e;
                let takeOutValue = [];
                actualGuidanceRegion[e].forEach((i) => {
                    takeOutValue.push(i);
                });
                allActualRegionData[e] = takeOutValue;
            });
        }
        allActualRegionData["VideoTimer"] = `${minutes} : ${seconds}`;
        allActualRegionData["angleDetected"] = angleDetectedGyro;
        allActualRegionData["lowLightImage"] = WholeLightLumaData;
        allActualRegionData["DialStatus"] = finalRegionsMap;
        allActualRegionData["currentUploadedPartCount"] = currentUploadedPartCount;
        actualRegion(allActualRegionData, inspectionId);
        setImgCOunt(inspectionId, {
            regionWiseData,
            afterFrameimgValue,
            imgValue,
            ...allowImgURLmain,
            allActualRegionData,
        });

        if (
            Object.keys(config["video-page"]).includes("restrictUserIfallNotGreen") &&
            config["video-page"]["restrictUserIfallNotGreen"]
        ) {
            processCompleted = true;
            if (clicked) {
                if (allRegionsCovered) {
                    allGreenGlobal = true;
                    hiddenRestrictedCard = true;
                    cardRef.current.style.display = "none";
                    warnRef.current.style.display = "none";
                    stopBtn.current.style.display = "none";
                    settingsRef.current.style.display = "none";
                    incompleteRef.current.style.display = "none";
                    incompleteSecoundText.current.style.display = "none";
                    completeRef.current.style.display = "flex";
                    completeImgRestrictedRef.current.style.display = "none";
                    allGreen = true;
                } else {
                    completeImgRestrictedRef.current.style.display = "none";
                    completeRef.current.style.display = "none";
                    document.getElementById("window-arc2").style.display = "flex";
                    document.getElementById("window-arc2").style.top = "38%";
                    document.getElementById("window-arc2").style.left = "40%";
                    document.getElementById("window-arc2").style.zIndex = "4";
                    document.getElementById("window-arc2").style.height = "10%";
                    document.getElementById("window-arc2").style.width = "10%";
                    allGreen = false;
                    allGreenGlobal = false;
                    stopRecordingML = true;
                }
            }
        } else {
            completeRef.current.style.display = "none";
            completeImgRestrictedRef.current.style.display = "none";
        }


        if (
            Object.keys(config["video-page"]).includes("restrictUserIfallNotGreen") &&
            config["video-page"]["restrictUserIfallNotGreen"]
        ) {
            if (!hiddenRestrictedCard) {
                restrictedReviewRef.current.style.display = "flex";
            } else {
                if (stopRef.current.style.display !== "flex") {
                    if (["client_1381", "client_1381_prod"].includes(clientId)) {
                        if (submitFlag) {
                            setStopHiddenRef(true);
                            stopRecording2();
                        } else {
                            setStopHiddenRef(true);
                            ackoReviewRef.current.style.display = "flex";
                        }
                    } else {
                        setStopHiddenRef(true);
                        ackoReviewRef.current.style.display = "flex";
                    }
                } else {
                    stopRecording2();
                }
            }
        } else {
            if (stopRef.current.style.display !== "flex") {
                if (["client_1381", "client_1381_prod"].includes(clientId)) {
                    if (submitFlag) {
                        setStopHiddenRef(true);
                        stopRecording2();
                    } else {
                        setStopHiddenRef(true);
                        ackoReviewRef.current.style.display = "flex";
                    }
                } else {
                    setStopHiddenRef(true);
                    ackoReviewRef.current.style.display = "flex";
                }
            } else {
                stopRecording2();
            }
        }

        if (
            Object.keys(config["video-page"]).includes("restrictUserIfallNotGreen") &&
            config["video-page"]["restrictUserIfallNotGreen"]
        ) {
            if (!allGreenGlobal) {
                return;
            }
        }
    };

    const finalizeVideoRecording = async () => {
        sendMessageAcko();
        if (["client_1381", "client_1381_prod"].includes(clientId))
            setAckoRedisCompletionTagFlag();
        ////stopRecordingML = true;
        onceStop = false;
        processEnd = true;
        froudInterval = setInterval(() => {
            FraudImageUpload();
        }, 2000);
        patLogs("stop recording clicked", inspectionId);
        clearInterval(startTimer);
        delete allActualRegionData.lowLightImage;
        userLogs({
            position: 3,
            video_data: JSON.stringify(allActualRegionData),
            inspectionId,
        });

        handleNext();
    };

    const captureOdometerImg = () => {
        if (odometerBgInterval) {
            clearInterval(odometerBgInterval);
            odometerBgInterval = null;
            processEnd = true;
        }

        let img = captureImgFrame(false);
        if (img) {
            let region = Object.keys(config["video-page"]).includes("clientRegion")
                ? config["video-page"]["clientRegion"]
                : "eu-central-1";
            setGlobalImageQueue({
                name: "odometer.jpg",
                imgData: img,
                tag: "odometer",
                web_region: null,
                angle: null,
                env: 1,
                region: region,
                videoData: null,
                dialStatus: null,
            });
            addImageToList({
                name: "odometer.jpg",
                imgData: img,
                tag: "odometer",
                web_region: null,
                angle: null,
                env: 1,
                region: region,
                videoData: null,
                dialStatus: null,
            });
            setShowOdometerCapture(false);
            finalizeVideoRecording();
        }
    };

    const stopRecording2 = async () => {
        if (ackoReviewRef.current) ackoReviewRef.current.style.display = "none";
        if (reviewRef.current) reviewRef.current.style.display = "none";
        if (restrictedReviewRef.current) restrictedReviewRef.current.style.display = "none";
        if (stopBtn.current) stopBtn.current.style.display = "none";
        if (stopRef.current) stopRef.current.style.display = "none";
        if (textRefDiv.current) textRefDiv.current.style.display = "none";
        if (backRef.current) backRef.current.style.display = "none";
        if (document.getElementById("window-arc2")) document.getElementById("window-arc2").style.display = "none";

        if (timerRef && timerRef.current) timerRef.current.style.display = "none";

        // Ensure stray pre-recording intervals are instantly killed to prevent "Front" tags
        if (preRecordingInterval) {
            clearInterval(preRecordingInterval);
            preRecordingInterval = null;
        }

        setShowOdometerCapture(true);

        // Start dedicated 1 FPS upload loop for Odometer with dynamic gyro logic mapping
        if (odometerBgInterval) clearInterval(odometerBgInterval);
        odometerBgInterval = setInterval(() => {
            if (!processEnd) {
                let img = captureImgFrame(false);
                if (img && currentGyroRegion) {
                    let region = Object.keys(config["video-page"]).includes("clientRegion")
                        ? config["video-page"]["clientRegion"]
                        : "eu-central-1";
                    setGlobalImageQueue({
                        name: `${captured}.jpg`,
                        imgData: img,
                        tag: `${currentGyroRegion}_interim`,
                        angle: currentGyroAngle,
                        web_region: currentGyroRegion,
                        env: 1,
                        region: region,
                        videoData: null,
                        dialStatus: null,
                    });
                    addImageToList({
                        name: `${captured}.jpg`,
                        imgData: img,
                        tag: `${currentGyroRegion}_interim`,
                        angle: currentGyroAngle,
                        web_region: currentGyroRegion,
                        env: 1,
                        region: region,
                        videoData: null,
                        dialStatus: null,
                    });
                }
            }
        }, 2000);
    };

    const setAckoRedisCompletionTagFlag = async () => {
        if (allGreen) {
            setAckoAnyGreyFlag(false);
        } else {
            const totalGreyReion = Object.values(finalRegionsMap).filter(
                (value) => value === 0,
            ).length;
            if (totalGreyReion <= 0) {
                setAckoAnyGreyFlag(false);
            }
        }
    };

    const showModal = (e) => {
        modalImg.current.src = images[e.target.dataset.index].imgData;
        modalRef.current.classList.add("active");
    };

    const hideModal = () => {
        modalRef.current.classList.remove("active");
    };

    const back = () => {
        if (preRecordingInterval) {
            clearInterval(preRecordingInterval);
            preRecordingInterval = null;
        }
        if (odometerBgInterval) {
            clearInterval(odometerBgInterval);
            odometerBgInterval = null;
        }
        logbugs = true;
        window.stream = null;
        track.stop();
        patLogs("clicked back button", inspectionId);
        if (["opes_prod", "opes_uat"].includes(clientId)) {
            setScreen("menuOpes");
        } else {
            setScreen("menu");
        }
    };

    const handleNext = () => {
        clearInterval(froudInterval);
        if (odometerBgInterval) {
            clearInterval(odometerBgInterval);
            odometerBgInterval = null;
            processEnd = true;
        }
        if (preRecordingInterval) {
            clearInterval(preRecordingInterval);
            preRecordingInterval = null;
        }
        active = false;
        logbugs = false;
        processEnd = true;
        patLogs("video module is completed", inspectionId);
        setTimeout(() => {
            if (currentBlock["mandatory"] && captured > 0) {
                let temp1 = mandatory;
                temp1[currentBlock["id"]] = "completed";
                setMandatory(temp1);
            }
            if (captured > 0) {
                let temp = condition;
                temp[currentBlock["id"]] = "completed";
                setCondition(temp);
                setLog(`${currentBlock["tag"]} was captured`);
                resumeFlowFinalSubmitHandler(currentBlock["id"]);
            }
            fameInterval = setInterval(() => {
                // console.log(
                //     "getAllFrameUpload",
                //     getAllFrameUpload,
                //     "allFrameUpload",
                //     allFrameUpload
                // );
                if (getAllFrameUpload) {
                    clearInterval(fameInterval);
                    setPortoModuleComplete(currentBlock["tag"]);
                    if (
                        Object.keys(config).includes("directModule")
                    ) {
                        clearInterval(startTimer);
                        setVideoFlag(false);
                        setScreen("success");
                    } else {
                        clearInterval(startTimer);
                        setVideoFlag(false);
                        if (["opes_prod", "opes_uat"].includes(clientId)) {
                            setScreen("menuOpes");
                        } else {
                            setScreen("menu");
                        }
                    }
                }
            }, 10);
        }, 1000);
    };

    const setMandatoryCondition = async () => {
        let tempCondition = condition,
            tempMandatory = mandatory,
            tempSubMandatoryCondtion = subMandatory,
            tempSubCondtion = subCondition;
        tempCondition[IMG360CONFIG["id"]] = "pending";
        tempCondition[currentBlock["id"]] = "completed";
        setCondition(tempCondition);

        tempMandatory[IMG360CONFIG["id"]] = "pending";
        tempMandatory[currentBlock["id"]] = "completed";
        setMandatory(tempMandatory);

        tempSubMandatoryCondtion[IMG360CONFIG["id"]] = {};
        tempSubCondtion[IMG360CONFIG["id"]] = {};
        IMG360CONFIG.values.map((item2) => {
            tempSubMandatoryCondtion[IMG360CONFIG["id"]][item2.name] = "pending";
            tempSubCondtion[IMG360CONFIG["id"]][item2.name] = "pending";
        });
        setSubMandatory(tempSubMandatoryCondtion);
        setSubCondition(tempSubCondtion);
    };

    useEffect(() => {
        isVideoRecordingActive = false;
        active = true;
        startTimer = null;
        allRegionsCovered = false;
        allGreen = false;
        modalFlag = false;
        images = [];
        endTimer = 0;
        odometerBgInterval = null;
        currentGyroAngle = null;
        currentGyroRegion = null;
        setStopPing(null);
        errorPrintCount = 0;
        startCamera();
        return () => {
            if (odometerBgInterval) {
                clearInterval(odometerBgInterval);
                odometerBgInterval = null;
                processEnd = true;
            }
        }
    }, []);

    useEffect(() => {
        tempVIN = vinPosition;
        setVinPositionAngle(
            vinPosition === "engineVin"
                ? 0
                : vinPosition === "windshieldVin"
                    ? 0
                    : vinPosition === "rightFrontDoorVin"
                        ? 90
                        : vinPosition === "underbodyRightFrontWheelVin"
                            ? 45
                            : 0
        );
    }, [vinPosition]);

    return (
        <div
            id="screen3"
            ref={screen3}
            style={{
                position: "relative",
                height: ["porto_seguros"].includes(clientId) ? "90dvh" : "100dvh",
            }}
        >
            <canvas
                ref={canvasRef}
                id="ios-canvas"
                style={
                    getAspectRatioClientList(clientId, config)
                        ? {
                            width: "100vw",
                            height: "100vh",
                            objectFit: "contain",
                            backgroundColor: "black",
                            position: "absolute",
                            top: 0,
                            left: 0,
                        }
                        : { position: "absolute", top: 0, left: 0 }
                }
            ></canvas>
            <video
                ref={videoRef}
                id="videoWindow"
                style={
                    getAspectRatioClientList(clientId, config)
                        ? {
                            width: "100vw",
                            height: "100vh",
                            objectFit: "contain",
                            backgroundColor: "black",
                            position: "absolute",
                            top: 0,
                            left: 0,
                        }
                        : { position: "absolute", top: 0, left: 0 }
                }
                autoPlay
                playsInline
            ></video>
            <div
                ref={skipDiv}
                className="skipDiv"
                style={{
                    width: "90dvw",
                    maxWidth: "450px", // Limits width on larger screens
                    height: "auto",
                    minHeight: "200px",
                    zIndex: 10,
                    backgroundColor: "#ffffff",
                    borderRadius: "20px",
                    padding: "30px 24px",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "center",
                    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.25)",
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    textAlign: "center",
                    fontFamily: "system-ui, -apple-system, sans-serif",
                }}
            >
                <h3
                    style={{
                        fontSize: "1.1rem",
                        color: "#2c3e50",
                        lineHeight: "1.6",
                        margin: "0 0 24px 0",
                        fontWeight: "500",
                    }}
                >
                    {errorType
                        ? config["video-page"][
                        "It seems that video app is not compatible with your device. Do you want to switch to image app?"
                        ] ||
                        getTranslateText(
                            "It seems that video app is not compatible with your device. Do you want to switch to image app?",
                        )
                        : config["video-page"][
                        "Are you facing any issues with recording the video. Do you want to switch to image app?"
                        ] ||
                        getTranslateText(
                            "Are you facing any issues with recording the video. Do you want to switch to image app?",
                        )}
                </h3>

                <div
                    className="skipDivButtons"
                    style={{
                        display: "flex",
                        gap: "12px",
                        width: "100%",
                        marginTop: "auto",
                    }}
                >
                    {/* Continue Button - Secondary Action */}
                    <div
                        onClick={() => {
                            patLogs("User chose to continue with video module", inspectionId);
                            skipDiv.current.style.display = "none";
                            checkForRedirect();
                        }}
                        style={{
                            flex: 1,
                            padding: "14px 0",
                            borderRadius: "12px",
                            backgroundColor: "white",
                            color: config["colors"]["secoundaryBtn"]
                                ? config["colors"]["secoundaryBtn"]
                                : "black",
                            border: config["colors"]["secoundaryBtn"]
                                ? `2px solid ${config["colors"]["secoundaryBtn"]}`
                                : "2px solid black",
                            fontSize: "1rem",
                            fontWeight: "600",
                            cursor: "pointer",
                            textAlign: "center",
                            transition: "background 0.2s ease",
                        }}
                    >
                        {config["video-page"]["Continue"] || getTranslateText("Continue")}
                    </div>

                    {/* Switch Button - Primary Action */}
                    <div
                        onClick={async () => {
                            patLogs("User chose to switch to image module", inspectionId);
                            active = false;
                            window.stream = null;
                            track.stop();
                            clearInterval(startTimer);
                            await setMandatoryCondition();
                            setScreen("block");
                            setCurrentBlock(IMG360CONFIG);
                            skipDiv.current.style.display = "none";
                        }}
                        style={{
                            flex: 1,
                            padding: "14px 0",
                            borderRadius: "12px",
                            backgroundColor: config["colors"]["btn"],
                            color: "white",
                            fontSize: "1rem",
                            fontWeight: "600",
                            cursor: "pointer",
                            textAlign: "center",
                            transition: "background 0.2s ease",
                        }}
                    >
                        {config["video-page"]["Switch"] || getTranslateText("Switch")}
                    </div>
                </div>
            </div>
            <p ref={timerRef} id="video-instructions"></p>
            <p
                style={{ display: "none" }}
                ref={settingsRef}
                id="video-instructions"
            ></p>
            <div id="btn-car-container"></div>
            {Object.keys(config).includes("directModule") &&
                config["directModule"] ? (
                ""
            ) : (
                <div ref={backRef} className="back-btn" style={{ color: "white", zIndex: 5 }}>
                    <i class="fas fa-arrow-left fa-2x" onClick={back}></i>
                </div>
            )}
            {/* <div ref={backRef} className="back-btn" style={{ color: "white" }}>
        <i class="fas fa-arrow-left fa-2x" onClick={back}></i>
      </div> */}
            {!isCapturingVin && (
                <div
                    style={
                        ["porto_seguros", "porto_seguros_uat"].includes(clientId)
                            ? { top: "40%" }
                            : {}
                    }
                    ref={startBtn}
                    onClick={startRecording}
                    id="btn-android-start"
                ></div>
            )}

            {isCapturingVin && showManualCapture && (
                <div
                    style={{
                        backgroundImage: `url(${cameraImg})`,
                        backgroundSize: "37px 37px",
                        backgroundRepeat: "no-repeat",
                        objectFit: "cover",
                        backgroundPosition: "center",
                        display: "block",
                        zIndex: 20
                    }}
                    onClick={async () => {
                        let img = captureImgFrame(true);
                        if (img) {
                            let region = Object.keys(config["video-page"]).includes("clientRegion")
                                ? config["video-page"]["clientRegion"]
                                : "eu-central-1";

                            const completeCapture = () => {
                                setGlobalImageQueue({
                                    name: `VIN.jpg`,
                                    imgData: img,
                                    tag: "VIN",
                                    web_region: null,
                                    env: 1,
                                    angle: null,
                                    region: region,
                                    videoData: null,
                                    dialStatus: null,
                                });
                                addImageToList({
                                    name: `VIN.jpg`,
                                    imgData: img,
                                    tag: "VIN",
                                    web_region: null,
                                    env: 1,
                                    angle: null,
                                    region: region,
                                    videoData: null,
                                    dialStatus: null,
                                });
                                setIsCapturingVin(false);
                                setShowManualCapture(false);
                                vinDetecting.current.style.display = "none";
                                lowerMessagePopup.current.style.display = "none";
                            };

                            if (skipLambdaNextTime) {
                                if (backRef.current) backRef.current.style.display = "none";
                                completeCapture();
                                setSkipLambdaNextTime(false);
                                setTimeout(() => {
                                    startVideoRecordingMode();
                                }, 500);
                                return;
                            }

                            setShowManualCapture(false);
                            if (vinDetecting.current) vinDetecting.current.style.display = "none";
                            if (lowerMessagePopup.current) lowerMessagePopup.current.style.display = "none";

                            if (feedBackPopUp.current) feedBackPopUp.current.style.display = "flex";
                            if (backRef.current) backRef.current.style.display = "none";
                            if (feedBackPopText.current) feedBackPopText.current.innerHTML = getTranslateText("Hang tight! We’re analyzing your image — this will only take a few seconds.");
                            if (carInspectionRef.current) carInspectionRef.current.style.width = "17dvw";
                            if (feedbackBtnRef.current) feedbackBtnRef.current.style.display = "none";

                            try {
                                checkVin = await imageFeedbackLambda({
                                    inspection_id: inspectionId,
                                    image: getWebpImageFormat() && !isIOS ? img.replace(/^data:image\/webp;base64,/, "") : img.replace(/^data:image\/jpeg;base64,/, ""),
                                    tag: currentBlock && currentBlock["tag"] ? currentBlock["tag"] : "VIN",
                                    Vin_feedback: true,
                                    client_id: clientId,
                                    type: "vin",
                                    region: region === "eu-central-1" ? "eu-central-1" : "ap-south-1"
                                });

                                setMessage(checkVin && checkVin[0] ? checkVin[0] : "");

                                if (checkVin && checkVin[0]) patLogs(`VIN Feedback: ${checkVin[0]}`, inspectionId);
                                else patLogs(`VIN Feedback: ${JSON.stringify(checkVin)}`, inspectionId);

                                if (checkVin && checkVin[1]) {
                                    completeCapture();

                                    if (feedBackPopUp.current) feedBackPopUp.current.style.display = "none";
                                    if (feedbackSuccessTopPopRef.current) feedbackSuccessTopPopRef.current.style.display = "flex";
                                    if (feedbackSuccessBottomPopRef.current) feedbackSuccessBottomPopRef.current.style.display = "flex";
                                    setFeedbackBtnText(getTranslateText("Proceed"));

                                    if (!(Object.keys(config).includes("allowVinFeedbackEdit") && config["allowVinFeedbackEdit"])) {
                                        setTimeout(() => {
                                            if (feedbackSuccessTopPopRef.current) feedbackSuccessTopPopRef.current.style.display = "none";
                                            if (feedbackSuccessBottomPopRef.current) feedbackSuccessBottomPopRef.current.style.display = "none";
                                            setTimeout(() => {
                                                startVideoRecordingMode();
                                            }, 500);
                                        }, 2000);
                                    }
                                } else {
                                    if (feedbackBtnRef.current) feedbackBtnRef.current.style.display = "flex";
                                    if (carInspectionRef.current) carInspectionRef.current.style.width = "10dvw";

                                    let errorMsg = getTranslateText("The VIN isn’t clearly visible. Please try capturing the image again.");
                                    if (checkVin && checkVin[0]) {
                                        let baseError = checkVin[0];
                                        if (!baseError.endsWith(".")) {
                                            baseError += ".";
                                        }
                                        errorMsg = `${baseError} ${getTranslateText("Please try capturing the image again.")}`;
                                    }
                                    if (feedBackPopText.current) feedBackPopText.current.innerHTML = `<span style="color:black; font-weight: bold">${errorMsg}</span>`;
                                }
                            } catch (error) {
                                console.error(error);
                                if (feedbackBtnRef.current) feedbackBtnRef.current.style.display = "flex";
                                if (carInspectionRef.current) carInspectionRef.current.style.width = "10dvw";
                                if (feedBackPopText.current) feedBackPopText.current.innerHTML = `<span style="color:black; font-weight: bold">Error analyzing VIN. Please try again.</span>`;
                            }
                        }
                    }}
                    id="btn-vin-start"
                ></div>
            )}
            <div ref={upArrow} className="upArrow">
                <img src={arrowUp} />
                <p>
                    {Object.keys(config["video-page"]).includes("videoNudges")
                        ? config["video-page"]["videoNudges"]["Point your camera to"]
                        : getTranslateText("Point your camera to")}{" "}
                    <span ref={arrowUpText}></span>
                </p>
            </div>
            <div ref={downArrow} className="downArrow">
                <img src={arrowDown} />
                <p>
                    {Object.keys(config["video-page"]).includes("videoNudges")
                        ? config["video-page"]["videoNudges"]["Point your camera to"]
                        : getTranslateText("Point your camera to")}{" "}
                    <span ref={arrowDownText}></span>
                </p>
            </div>

            <div
                ref={stopBtn}
                onClick={() =>
                    hideRecordbutton && stopRef.current.style.display === "flex"
                        ? ""
                        : stopRecording(true, false)
                }
                id="btn-android-stop"
                style={{
                    visibility: hiddenStopRef ? "hidden" : "",
                    top: ["porto_seguros", "porto_seguros_uat"].includes(clientId)
                        ? "40%"
                        : "",
                }}
            ></div>
            <div id="window-arc2">
                <img src={carsmall} alt="" className="car" />
                {enableVInCanvas2 ? (
                    <div className="canvas-wrapper">
                        <canvas ref={canvasVIN} width="100" height="100"></canvas>
                        <div
                            className="rotating-arrow"
                            style={{
                                transform: `rotate(${vinPositionAngle + 270
                                    }deg) translate(50px) rotate(-${vinPositionAngle + 270}deg)`,
                            }}
                        >
                            <div
                                style={{
                                    transform: `rotate(${vinPositionAngle}deg)`,
                                }}
                            >
                                <img src={vinPointingArrow} alt="Arrow" />
                            </div>
                        </div>
                    </div>
                ) : (
                    <canvas ref={canvas1} width="100" height="100"></canvas>
                )}
            </div>

            <div
                className="allgreenstop1"
                ref={stopRef}
                style={
                    ["porto_seguros", "porto_seguros_uat"].includes(clientId)
                        ? { top: "5%", height: "70%" }
                        : {}
                }
            >
                <div className="pre-start-card" style={{ width: "40%", height: "70%" }}>
                    <strong
                        style={{
                            fontSize: "12px",
                            transform: ["porto_seguros", "porto_seguros_uat"].includes(
                                clientId,
                            )
                                ? ""
                                : "rotate(-90deg)",
                            paddingRight: ["porto_seguros", "porto_seguros_uat"].includes(
                                clientId,
                            )
                                ? "2%"
                                : "",
                        }}
                    >
                        {config["video-page"]["left-text"]}
                    </strong>
                    <div className="car-flex">
                        <strong style={{ textAlign: "center", fontSize: "12px" }}>
                            {config["video-page"]["front-text"]}
                        </strong>
                        <canvas ref={canvas5} width="150" height="150"></canvas>
                        <strong style={{ fontSize: "12px" }}>
                            {config["video-page"]["rear-text"]}
                        </strong>
                    </div>
                    <strong
                        style={{
                            fontSize: "12px",
                            transform: ["porto_seguros", "porto_seguros_uat"].includes(
                                clientId,
                            )
                                ? ""
                                : "rotate(90deg)",
                            paddingLeft: ["porto_seguros", "porto_seguros_uat"].includes(
                                clientId,
                            )
                                ? "2%"
                                : "",
                        }}
                    >
                        {config["video-page"]["right-text"]}
                    </strong>
                    <div style={{ width: "20px" }}></div>
                </div>
                {["porto_seguros", "porto_seguros_uat"].includes(clientId) && (
                    <div style={{ marginLeft: "4%" }} class="divider"></div>
                )}
                <div
                    className="allgreenstop_bodyDiv"
                    style={
                        ["porto_seguros", "porto_seguros_uat"].includes(clientId)
                            ? { padding: "0% 3%" }
                            : {}
                    }
                >

                    {["porto_seguros", "porto_seguros_uat"].includes(clientId) ? (
                        <h4>{config["video-page"]["stopText"]}</h4>
                    ) : (
                        <h3 style={{ width: "90%" }}>{config["video-page"]["stopText"]}</h3>
                    )}
                    {/* <h4 style={{ margin: 0 }} ref={hRef}>
            {Object.keys(config["video-page"]).includes("lowLightRegion")
              ? config["video-page"]["lowLightRegion"]
              : "Regions in Low Light:"}{" "}
            <span
              ref={lowLightRegion}
              style={{ margin: 0, fontWeight: 100 }}
            ></span>
          </h4> */}
                    <div
                        className="modal-btn-container"
                        style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                        {["porto_seguros", "porto_seguros_uat"].includes(clientId) ? (
                            <button
                                style={{
                                    backgroundColor: config["colors"]["btn"],
                                    color: "white",
                                    width: "100%",
                                    height: "200%",
                                }}
                                onClick={() => {
                                    setRestrictUserIfallNotGreen(true);
                                    clearInterval(intervalId2);
                                    stopRecording(true, false);
                                    clearInterval(startTimer);
                                }}
                            >
                                {Object.keys(config["video-page"]).includes("stopRecordingText")
                                    ? config["video-page"]["stopRecordingText"]
                                    : getTranslateText("Stop Recording")}
                            </button>
                        ) : (
                            <Button
                                marginDefault="0px"
                                text={config["video-page"]["stopRecordingText"]}
                                onclick={() => {
                                    setRestrictUserIfallNotGreen(true);
                                    clearInterval(intervalId2);
                                    stopRecording(true, false);
                                    clearInterval(startTimer);
                                }}
                            />
                        )}
                    </div>
                </div>
            </div>

            <div className="allgreenstop3" ref={timeUpRef}>
                <div className="allgreenstop3_title">
                    <h2>
                        {Object.keys(config["video-page"]).includes("timeup-text")
                            ? config["video-page"]["timeup-text"]
                            : getTranslateText("Video can only be seven minutes long.")}
                    </h2>
                </div>

                {Object.keys(config["video-page"]).includes(
                    "videoTimeoutRefreshLink"
                ) && (
                        <>
                            <div className="allgreenstop3_body">
                                <h4 style={{ fontWeight: "600", margin: "0px", padding: "0px" }}>
                                    {Object.keys(
                                        config["video-page"]["videoTimeoutRefreshLink"]
                                    ).includes("time-limitup-text-1")
                                        ? config["video-page"]["videoTimeoutRefreshLink"][
                                        "time-limitup-text-1"
                                        ]
                                        : getTranslateText(
                                            "Due to our strict 7-minute policy, all videos and photos captured so far will be deleted."
                                        )}{" "}
                                    <span style={{ color: "red" }}>
                                        {Object.keys(
                                            config["video-page"]["videoTimeoutRefreshLink"]
                                        ).includes("time-limitup-text-2")
                                            ? config["video-page"]["videoTimeoutRefreshLink"][
                                            "time-limitup-text-2"
                                            ]
                                            : getTranslateText(
                                                "You will need to restart the inspection process."
                                            )}
                                    </span>
                                </h4>
                            </div>
                            <div className="allgreenstop3_btn">
                                <Button
                                    text={
                                        Object.keys(
                                            config["video-page"]["videoTimeoutRefreshLink"]
                                        ).includes("restartText_btn")
                                            ? config["video-page"]["videoTimeoutRefreshLink"][
                                            "restartText_btn"
                                            ]
                                            : getTranslateText("Restart inspection")
                                    }
                                    onclick={() => {
                                        location.reload();
                                    }}
                                />
                            </div>
                        </>
                    )}
            </div>

            {/* <div className="allgreenstop2" ref={timeUpRef}>
        <h3>
          {Object.keys(config["video-page"]).includes("timeup-text")
            ? config["video-page"]["timeup-text"]
            : "Video can only be seven minutes long."}
        </h3>
      </div> */}

            <div
                className="allgreenstop2"
                ref={angleRef}
                style={
                    ["porto_seguros", "porto_seguros_uat"].includes(clientId)
                        ? { top: "5%", height: "72%" }
                        : {}
                }
            >
                <div
                    className="pre-start-card"
                    style={
                        ["porto_seguros", "porto_seguros_uat"].includes(clientId)
                            ? { width: "auto" }
                            : { width: "30%", height: "70%" }
                    }
                >
                    <strong
                        style={{
                            fontSize: "12px",
                            marginRight: "2px",
                            transform: ["porto_seguros", "porto_seguros_uat"].includes(
                                clientId,
                            )
                                ? ""
                                : "rotate(-90deg)",
                            paddingRight: ["porto_seguros", "porto_seguros_uat"].includes(
                                clientId,
                            )
                                ? "2%"
                                : "",
                        }}
                    >
                        {config["video-page"]["left-text"]}
                    </strong>
                    <div className="car-flex">
                        <strong
                            style={{
                                marginBottom: "8px",
                                textAlign: "center",
                                fontSize: "12px",
                            }}
                        >
                            {config["video-page"]["front-text"]}
                        </strong>
                        <canvas ref={canvas4} width="150" height="150"></canvas>
                        <strong style={{ marginTop: "10px", fontSize: "12px" }}>
                            {config["video-page"]["rear-text"]}
                        </strong>
                    </div>
                    <strong
                        style={{
                            fontSize: "12px",
                            transform: ["porto_seguros", "porto_seguros_uat"].includes(
                                clientId,
                            )
                                ? ""
                                : "rotate(90deg)",
                            paddingLeft: ["porto_seguros", "porto_seguros_uat"].includes(
                                clientId,
                            )
                                ? "2%"
                                : "",
                        }}
                    >
                        {config["video-page"]["right-text"]}
                    </strong>
                    <div style={{ width: "20px" }}></div>
                </div>
                {["porto_seguros", "porto_seguros_uat"].includes(clientId) && (
                    <div class="divider"></div>
                )}
                <div
                    className="allgreenstop2_bodyDiv"
                    style={
                        ["porto_seguros", "porto_seguros_uat"].includes(clientId)
                            ? { padding: "0% 3%" }
                            : {}
                    }
                >
                    <div
                        className="allgreenstop2_innerDiv"
                        style={{ width: "100%", paddingBottom: "5%" }}
                    >
                        <h3 style={{ margin: "0px", padding: "0px", fontSize: "14px" }}>
                            {Object.keys(config["video-page"]).includes("one-revolution")
                                ? config["video-page"]["recordStopBtnEnable"]
                                    ? recordStopBtnFlag
                                        ? config["video-page"]["one-revolution"]
                                        : config["video-page"]["one-revolution-partial"]
                                    : config["video-page"]["one-revolution"]
                                : getTranslateText(
                                    "You have completed one revolution around the car.",
                                )}
                        </h3>
                        <div
                            className="notCoveredAreas"
                            id={
                                ["porto_seguros", "porto_seguros_uat"].includes(clientId)
                                    ? "scrollable-container"
                                    : ""
                            }
                            style={{ fontSize: "12px" }}
                        >
                            <p style={{ fontWeight: "600", margin: "0px", padding: "0px" }}>
                                {Object.keys(config["video-page"]).includes(
                                    "missed-region-text",
                                )
                                    ? config["video-page"]["recordStopBtnEnable"]
                                        ? recordStopBtnFlag
                                            ? config["video-page"]["missed-region-text"]
                                            : config["video-page"]["missed-region-text-partial"]
                                        : config["video-page"]["missed-region-text"]
                                    : getTranslateText(
                                        "Continue to capture missed regions:",
                                    )}{" "}
                                {["porto_seguros", "porto_seguros_uat"].includes(clientId) ? (
                                    unCaptureList.map((e) => (
                                        <li style={{ margin: 0, fontWeight: 100 }}>{e.trim()}</li>
                                    ))
                                ) : (
                                    <span
                                        ref={angleDetailRef}
                                        style={{ margin: 0, fontWeight: 100, color: "red" }}
                                    ></span>
                                )}
                            </p>
                            {/* <p style={{ fontWeight: '300' }} ref={hRef2}>
              {Object.keys(config["video-page"]).includes("lowLightRegion")
                ? config["video-page"]["lowLightRegion"]
                : "Regions in Low Light:"}{" "}
              <span
                ref={lowLightRegion2}
                style={{ margin: 0, fontWeight: 100 }}
              ></span>
            </p> */}
                        </div>
                    </div>

                    <div
                        className="modal-btn-container"
                        style={{ justifyContent: "flex-end" }}
                    >
                        {Object.keys(config["video-page"]).includes(
                            "restrictUserIfallNotGreen"
                        ) &&
                            config["video-page"]["restrictUserIfallNotGreen"] &&
                            allGreenGlobal && (
                                <Button
                                    marginDefault="0px"
                                    secoundaryBtn="true"
                                    text={config["video-page"]["stopRecordingText"]}
                                    onclick={() => {
                                        angleStop = false;
                                        angleRef.current.style.display = "none";
                                        stopRecording(true, true);
                                        clearInterval(intervalId);
                                    }}
                                />
                            )}
                        {recordStopBtnFlag &&
                            config["video-page"]["recordStopBtnEnable"] && (
                                <Button
                                    marginDefault="0px"
                                    secoundaryBtn="true"
                                    text={
                                        config["video-page"]["recordStopBtnText"]
                                            ? config["video-page"]["recordStopBtnText"]
                                            : getTranslateText("Submit")
                                    }
                                    onclick={() => {
                                        angleStop = false;
                                        angleRef.current.style.display = "none";
                                        stopRecording(true, false);
                                        clearInterval(intervalId);
                                    }}
                                />
                            )}
                        {["porto_seguros", "porto_seguros_uat"].includes(clientId) ? (
                            <button
                                style={{
                                    backgroundColor: config["colors"]["btn"],
                                    color: "white",
                                    width: "100%",
                                    height: "200%",
                                }}
                                onClick={() => {
                                    angleStop = false;
                                    angleRef.current.style.display = "none";
                                    guidance.pausePartCoveringAndFrameUpload = false;
                                    guidance.stage = 2;
                                    clearInterval(intervalId);
                                }}
                            >
                                {Object.keys(config["video-page"]).includes("continueText")
                                    ? config["video-page"]["continueText"]
                                    : getTranslateText("Continue")}
                            </button>
                        ) : (
                            <Button
                                marginDefault="0px"
                                text={config["video-page"]["continueText"]}
                                onclick={() => {
                                    angleStop = false;
                                    angleRef.current.style.display = "none";
                                    guidance.pausePartCoveringAndFrameUpload = false;
                                    guidance.stage = 2;
                                    clearInterval(intervalId);
                                }}
                            />
                        )}

                    </div>
                </div>
            </div>

            <div
                ref={cardRef}
                id="display-card"
                style={
                    ["porto_seguros", "porto_seguros_uat"].includes(clientId)
                        ? { height: "75%", top: "5%" }
                        : {}
                }
            >
                <div className="pre-start-card">
                    <strong
                        style={{
                            marginRight: "2px",
                            fontSize: "12px",
                            transform: ["porto_seguros", "porto_seguros_uat"].includes(
                                clientId,
                            )
                                ? ""
                                : "rotate(-90deg)",
                            paddingRight: ["porto_seguros", "porto_seguros_uat"].includes(
                                clientId,
                            )
                                ? "2%"
                                : "",
                        }}
                    >
                        {config["video-page"]["left-text"]}
                    </strong>
                    <div className="car-flex">
                        <strong
                            style={{
                                marginBottom: "8px",
                                textAlign: "center",
                                fontSize: "12px",
                            }}
                        >
                            {config["video-page"]["front-text"]}
                        </strong>
                        <img
                            ref={imgRef}
                            style={{ width: "12dvw" }}
                            src={
                                ["client_1433"].includes(clientId)
                                    ? initGreenImg
                                    : [
                                        "porto_seguros",
                                        "porto_seguros_uat",
                                        "client_834",
                                        "client_834_uat",
                                    ].includes(clientId)
                                        ? ["porto_seguros", "porto_seguros_uat"].includes(clientId)
                                            ? initBlueImgDot
                                            : initBlueImg
                                        : initBlueImgDot
                            }
                        ></img>
                        <strong style={{ marginTop: "10px" }}>
                            {config["video-page"]["rear-text"]}
                        </strong>
                    </div>
                    <strong
                        style={{
                            fontSize: "12px",
                            transform: ["porto_seguros", "porto_seguros_uat"].includes(
                                clientId,
                            )
                                ? ""
                                : "rotate(90deg)",
                            paddingLeft: ["porto_seguros", "porto_seguros_uat"].includes(
                                clientId,
                            )
                                ? "2%"
                                : "",
                        }}
                    >
                        {config["video-page"]["right-text"]}
                    </strong>
                    <div style={{ width: "20px" }}></div>
                </div>
                {["porto_seguros", "porto_seguros_uat"].includes(clientId) && (
                    <div class="divider"></div>
                )}
                <div className="card-info">
                    <div>
                        <div className="car-green"></div>
                        <b
                            style={{
                                fontSize: "14px",
                                fontWeight: ["porto_seguros", "porto_seguros_uat"].includes(
                                    clientId,
                                )
                                    ? "unset"
                                    : "",
                            }}
                        >
                            {config["video-page"]["covered-text"]}
                        </b>
                    </div>
                    <div
                        style={
                            ["porto_seguros", "porto_seguros_uat"].includes(clientId)
                                ? { padding: "3% 0%" }
                                : {}
                        }
                    >
                        <div
                            className="car-red"
                            style={{
                                backgroundColor: ["client_1433"].includes(clientId)
                                    ? "#FFFF00"
                                    : [
                                        "porto_seguros",
                                        "porto_seguros_uat",
                                        "client_834",
                                        "client_834_uat",
                                    ].includes(clientId)
                                        ? "#02CCFE"
                                        : "#02CCFE",
                            }}
                        ></div>
                        <b
                            style={{
                                fontSize: "14px",
                                fontWeight: ["porto_seguros", "porto_seguros_uat"].includes(
                                    clientId,
                                )
                                    ? "unset"
                                    : "",
                            }}
                        >
                           {getTranslateText("Blue represents that this side is not captured perfectly.")}
                        </b>
                    </div>
                    {["porto_seguros", "porto_seguros_uat"].includes(clientId) && (
                        <div>
                            <div className="red-circle"></div>
                            <b style={{ fontWeight: "unset", fontSize: "14px" }}>
                                {config["video-page"]["circle-red-text"]}
                            </b>
                        </div>
                    )}
                    <div className="card-note">
                        {["porto_seguros", "porto_seguros_uat"].includes(clientId) && (
                            <div className="car-white"></div>
                        )}
                        <p
                            ref={loaderGuidanceText}
                            style={{ width: "100%", fontSize: "14px" }}
                        ></p>
                        {Object.keys(config).includes("directModule") ||
                            clientId === "hc_pilot" ? (
                            <div className="progress" id="progress_loader"></div>
                        ) : (
                            <img
                                id="model-loader"
                                src="https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/video_model_loader.gif"
                                alt="abc"
                            />
                        )}
                    </div>
                </div>
            </div>

            <div
                ref={startRef}
                id="stop-display-card"
                style={
                    ["porto_seguros", "porto_seguros_uat"].includes(clientId)
                        ? { height: "75%", top: "5%" }
                        : {}
                }
            >
                <div className="pre-start-card">
                    <strong
                        style={{
                            fontSize: "12px",
                            marginRight: "2px",
                            transform: ["porto_seguros", "porto_seguros_uat"].includes(
                                clientId,
                            )
                                ? ""
                                : "rotate(-90deg)",
                            paddingRight: ["porto_seguros", "porto_seguros_uat"].includes(
                                clientId,
                            )
                                ? "2%"
                                : "",
                        }}
                    >
                        {config["video-page"]["left-text"]}
                    </strong>
                    <div className="car-flex">
                        <strong
                            style={{
                                marginBottom: "8px",
                                textAlign: "center",
                                fontSize: "12px",
                            }}
                        >
                            {config["video-page"]["front-text"]}
                        </strong>
                        <img
                            ref={imgRef}
                            src={
                                ["client_1433"].includes(clientId)
                                    ? initGreenImg
                                    : [
                                        "porto_seguros",
                                        "porto_seguros_uat",
                                        "client_834",
                                        "client_834_uat",
                                    ].includes(clientId)
                                        ? ["porto_seguros", "porto_seguros_uat"].includes(clientId)
                                            ? initBlueImgDot
                                            : initBlueImg
                                        : initBlueImgDot
                            }
                        ></img>
                        <strong style={{ marginTop: "10px", fontSize: "12px" }}>
                            {config["video-page"]["rear-text"]}
                        </strong>
                    </div>
                    <strong
                        style={{
                            fontSize: "12px",
                            transform: ["porto_seguros", "porto_seguros_uat"].includes(
                                clientId,
                            )
                                ? ""
                                : "rotate(90deg)",
                            paddingLeft: ["porto_seguros", "porto_seguros_uat"].includes(
                                clientId,
                            )
                                ? "2%"
                                : "",
                        }}
                    >
                        {config["video-page"]["right-text"]}
                    </strong>
                    <div style={{ width: "20px" }}></div>
                </div>
                {["porto_seguros", "porto_seguros_uat"].includes(clientId) && (
                    <div class="divider"></div>
                )}
                <div className="card-info">
                    <div>
                        <div className="car-green"></div>
                        <b
                            style={{
                                fontSize: "14px",
                                width: "90%",
                                fontWeight: ["porto_seguros", "porto_seguros_uat"].includes(
                                    clientId,
                                )
                                    ? "unset"
                                    : "",
                            }}
                        >
                            {config["video-page"]["covered-text"]}
                        </b>
                    </div>
                    <div
                        style={
                            ["porto_seguros", "porto_seguros_uat"].includes(clientId)
                                ? { padding: "3% 0%" }
                                : {}
                        }
                    >
                        <div
                            className="car-red"
                            style={{
                                backgroundColor: ["client_1433"].includes(clientId)
                                    ? "#FFFF00"
                                    : [
                                        "porto_seguros",
                                        "porto_seguros_uat",
                                        "client_834",
                                        "client_834_uat",
                                    ].includes(clientId)
                                        ? "#02CCFE"
                                        : "#02CCFE",
                            }}
                        ></div>
                        <b
                            style={{
                                width: "90%",
                                fontSize: "14px",
                                fontWeight: ["porto_seguros", "porto_seguros_uat"].includes(
                                    clientId,
                                )
                                    ? "unset"
                                    : "",
                            }}
                        >
                           {getTranslateText("Blue represents that this side is not captured perfectly.")}
                        </b>
                    </div>
                    {["porto_seguros", "porto_seguros_uat"].includes(clientId) && (
                        <div>
                            <div className="red-circle"></div>
                            <b
                                style={{ width: "90%", fontWeight: "unset", fontSize: "14px" }}
                            >
                                {config["video-page"]["circle-red-text"]}
                            </b>
                        </div>
                    )}
                    <div className="card-note">
                        {["porto_seguros", "porto_seguros_uat"].includes(clientId) && (
                            <div className="car-white"></div>
                        )}
                        <p ref={modalGuidanceText} style={{ fontSize: "14px" }}></p>
                    </div>
                </div>
            </div>
            <div ref={textRefDiv}>
                <p ref={textRef} id="video-recording-text"></p>
            </div>

            {/* acko recent changes */}
            <div ref={ackoReviewRef} id="acko-review-card">
                <div
                    className="pre-start-card"
                    style={{ width: "15%", height: "70%", paddingLeft: "12%" }}
                >
                    <strong style={{ transform: "rotate(-90deg)", fontSize: "12px" }}>
                        {config["video-page"]["left-text"]}
                    </strong>
                    <div className="car-flex">
                        <strong style={{ marginBottom: "8px", fontSize: "12px" }}>
                            {config["video-page"]["front-text"]}
                        </strong>
                        <img src={carsmall} alt="" id="ackoCar" />
                        <canvas ref={canvas7} width="120" height="120"></canvas>
                        <strong style={{ marginTop: "10px", fontSize: "12px" }}>
                            {config["video-page"]["rear-text"]}
                        </strong>
                    </div>
                    <strong style={{ transform: "rotate(90deg)", fontSize: "12px" }}>
                        {config["video-page"]["right-text"]}
                    </strong>
                </div>
                <div className="allgreenstop2_bodyDiv">
                    <div
                        style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            gap: "10px",
                            paddingRight: "2%",
                            height: "80%",
                        }}
                    >
                        {/* <h3 style={{ margin: "0px", padding: "0px" }} ref={incompleteRef}>
                            {Object.keys(config["video-page"]).includes("newIncompleteText")
                                ? config["video-page"]["incompleteText"]
                                : getTranslateText("Are you sure you want to stop recording?")}
                        </h3>
                        <p id="incomplete-secoundText" ref={incompleteSecoundText}>
                            {Object.keys(config["video-page"]).includes(
                                "incomplete-secound-text"
                            )
                                ? config["video-page"]["incomplete-secound-text"]
                                : ""}
                        </p> */}
                        {notDetectedFlag ? (
                            <>
                                <h3
                                    style={{ margin: "0px", padding: "0px" }}
                                    ref={incompleteRef}
                                >
                                    {Object.keys(config["video-page"]).includes(
                                        "newIncompleteText",
                                    )
                                        ? config["video-page"]["newIncompleteText"]
                                        : getTranslateText(
                                            "Are you sure you want to stop recording?",
                                        )}
                                </h3>
                                {[
                                    "porto_seguros",
                                    "porto_seguros_uat",
                                    "hc_pilot",
                                    "arval_dev",
                                ].includes(clientId) ? (
                                    <p></p>
                                ) : (
                                    <p id="incomplete-secoundText" ref={incompleteSecoundText}>
                                        {Object.keys(config["video-page"]).includes(
                                            "incomplete-secound-text",
                                        )
                                            ? config["video-page"]["incomplete-secound-text"]
                                            : ""}
                                    </p>
                                )}
                            </>
                        ) : (
                            <h3 style={{ margin: "0px", padding: "0px" }} ref={incompleteRef}>
                                {Object.keys(config["video-page"]).includes(
                                    "notCoverAnySideText",
                                )
                                    ? config["video-page"]["notCoverAnySideText"]
                                    : "You didn’t cover all side, please cover all the side."}
                            </h3>
                        )}
                    </div>
                    <div className="modal-btn-container">
                        {!allGreenGlobal && notDetectedFlag && (
                            <Button
                                secoundaryBtn="true"
                                id="ackoBtn"
                                text={
                                    config["video-page"]["ackoStopRecordingText"]
                                        ? config["video-page"]["ackoStopRecordingText"]
                                        : getTranslateText("Stop recording")
                                }
                                onclick={() => stopRecording2()}
                            // onclick={() => stopRecording()}
                            />
                        )}
                        {!allGreenGlobal && (
                            <Button
                                text={
                                    config["video-page"]["continueRecordingText"]
                                        ? config["video-page"]["restrictionBtn"]
                                        : getTranslateText("Continue")
                                }
                                onclick={() => {
                                    setStopHiddenRef(false);
                                    ackoReviewRef.current.style.display = "none";
                                    document.getElementById("window-arc2").style.top = "";
                                    document.getElementById("window-arc2").style.left = "";
                                    document.getElementById("window-arc2").style.right = "30px";
                                    document.getElementById("window-arc2").style.bottom = "25px";
                                    document.getElementById("window-arc2").style.zIndex = "";
                                    document.getElementById("window-arc2").style.height = "79px";
                                    document.getElementById("window-arc2").style.width = "79px";
                                }}
                            />
                        )}
                    </div>
                </div>
            </div>


            {/* 
            <div ref={reviewRef} id="review-card">
                <h4 ref={completeRef}>{config["video-page"]["completeText"]}</h4>
                <h4 ref={incompleteRef}>{config["video-page"]["incompleteText"]}</h4>
                <canvas ref={canvas6} width="150" height="150"></canvas>
                <div className="review-btns">
                    <Button
                        text={config["video-page"]["btnText"]}
                        onclick={() => {
                            if (
                                Object.keys(config["video-page"]).includes(
                                    "restrictUserIfallNotGreen"
                                ) &&
                                config["video-page"]["restrictUserIfallNotGreen"]
                            ) {
                                if (allGreenGlobal) {
                                    stopRecording2();
                                } else {
                                    reviewRef.current.style.display = "none";
                                    document.getElementById("window-arc2").style.top = "";
                                    document.getElementById("window-arc2").style.left = "";
                                    document.getElementById("window-arc2").style.right = "30px";
                                    document.getElementById("window-arc2").style.bottom = "25px";
                                    document.getElementById("window-arc2").style.zIndex = "";
                                    document.getElementById("window-arc2").style.height = "79px";
                                    document.getElementById("window-arc2").style.width = "79px";
                                }
                            } else {
                                stopRecording2();
                            }
                        }}
                    ></Button>
                </div>
            </div> */}
            <div
                ref={reviewRef}
                id="review-card"
                style={
                    ["porto_seguros", "porto_seguros_uat"].includes(clientId)
                        ? { top: "8%", height: "70%" }
                        : {}
                }
            >
                <div className="pre-start-card" style={{ width: "40%", height: "70%" }}>
                    <strong
                        style={{
                            fontSize: "12px",
                            transform: ["porto_seguros", "porto_seguros_uat"].includes(
                                clientId,
                            )
                                ? ""
                                : "rotate(-90deg)",
                            paddingRight: ["porto_seguros", "porto_seguros_uat"].includes(
                                clientId,
                            )
                                ? "2%"
                                : "",
                        }}
                    >
                        {config["video-page"]["left-text"]}
                    </strong>
                    <div className="car-flex">
                        <strong style={{ textAlign: "center", fontSize: "12px" }}>
                            {config["video-page"]["front-text"]}
                        </strong>
                        <canvas ref={canvas6} width="150" height="150"></canvas>
                        <strong style={{ fontSize: "12px" }}>
                            {config["video-page"]["rear-text"]}
                        </strong>
                    </div>
                    <strong
                        style={{
                            fontSize: "12px",
                            transform: ["porto_seguros", "porto_seguros_uat"].includes(
                                clientId,
                            )
                                ? ""
                                : "rotate(90deg)",
                            paddingLeft: ["porto_seguros", "porto_seguros_uat"].includes(
                                clientId,
                            )
                                ? "2%"
                                : "",
                        }}
                    >
                        {config["video-page"]["right-text"]}
                    </strong>
                    <div style={{ width: "20px" }}></div>
                </div>
                {["porto_seguros", "porto_seguros_uat"].includes(clientId) && (
                    <div style={{ marginLeft: "4%" }} class="divider"></div>
                )}
                <div
                    className="allgreenstop_bodyDiv"
                    style={
                        ["porto_seguros", "porto_seguros_uat"].includes(clientId)
                            ? { padding: "0% 3%" }
                            : {}
                    }
                >
                    <h3 style={{ width: "90%" }} ref={completeRef}>
                        {config["video-page"]["completeText"]}
                    </h3>
                    <h3 style={{ width: "90%" }} ref={incompleteRef}>
                        {config["video-page"]["incompleteText"]}
                    </h3>
                    <div className="modal-btn-container" style={{ display: "flex" }}>
                        {["porto_seguros", "porto_seguros_uat"].includes(clientId) ? (
                            <button
                                style={{
                                    backgroundColor: config["colors"]["btn"],
                                    color: "white",
                                    width: "100%",
                                    height: "200%",
                                }}
                                onClick={() => {
                                    if (
                                        Object.keys(config["video-page"]).includes(
                                            "restrictUserIfallNotGreen",
                                        ) &&
                                        config["video-page"]["restrictUserIfallNotGreen"]
                                    ) {
                                        if (allGreenGlobal) {
                                            stopRecording2();
                                            // stopRecording();
                                        } else {
                                            reviewRef.current.style.display = "none";
                                            document.getElementById("window-arc2").style.top = "";
                                            document.getElementById("window-arc2").style.left = "";
                                            document.getElementById("window-arc2").style.right =
                                                "30px";
                                            document.getElementById("window-arc2").style.bottom =
                                                "25px";
                                            document.getElementById("window-arc2").style.zIndex = "";
                                            document.getElementById("window-arc2").style.height =
                                                "79px";
                                            document.getElementById("window-arc2").style.width =
                                                "79px";
                                        }
                                    } else {
                                        stopRecording2();
                                        //stopRecording();
                                    }
                                }}
                            >
                                {Object.keys(config["video-page"]).includes("btnText")
                                    ? config["video-page"]["btnText"]
                                    : getTranslateText("Stop Recording")}
                            </button>
                        ) : (
                            <Button
                                marginDefault="0px"
                                text={config["video-page"]["btnText"]}
                                onclick={() => {
                                    if (
                                        Object.keys(config["video-page"]).includes(
                                            "restrictUserIfallNotGreen",
                                        ) &&
                                        config["video-page"]["restrictUserIfallNotGreen"]
                                    ) {
                                        if (allGreenGlobal) {
                                            stopRecording2();
                                            //stopRecording();
                                        } else {
                                            reviewRef.current.style.display = "none";
                                            document.getElementById("window-arc2").style.top = "";
                                            document.getElementById("window-arc2").style.left = "";
                                            document.getElementById("window-arc2").style.right =
                                                "30px";
                                            document.getElementById("window-arc2").style.bottom =
                                                "25px";
                                            document.getElementById("window-arc2").style.zIndex = "";
                                            document.getElementById("window-arc2").style.height =
                                                "79px";
                                            document.getElementById("window-arc2").style.width =
                                                "79px";
                                        }
                                    } else {
                                        stopRecording2();
                                        //stopRecording();
                                    }
                                }}
                            />
                        )}
                    </div>
                </div>
            </div>

            <div ref={restrictedReviewRef} id="review-restricted-card">
                <h4>
                    {config["video-page"]["restrictionText"]
                        ? config["video-page"]["restrictionText"]
                        : getTranslateText(
                            "You can't move to next step until you complete all section to green"
                        )}
                </h4>
                <img ref={completeImgRestrictedRef} src={indicator}></img>
                <div className="review-btns">
                    <Button
                        text={
                            config["video-page"]["restrictionBtn"]
                                ? config["video-page"]["restrictionBtn"]
                                : getTranslateText("Continue Recording")
                        }
                        onclick={() => {
                            restrictedReviewRef.current.style.display = "none";
                            document.getElementById("window-arc2").style.top = "";
                            document.getElementById("window-arc2").style.left = "";
                            document.getElementById("window-arc2").style.right = "30px";
                            document.getElementById("window-arc2").style.bottom = "25px";
                            document.getElementById("window-arc2").style.zIndex = "";
                            document.getElementById("window-arc2").style.height = "79px";
                            document.getElementById("window-arc2").style.width = "79px";
                        }}
                    ></Button>
                </div>
            </div>

            <div ref={warnRef} id="warn-card">
                <Rotate />
                <p className="note">{config["video-page"]["rotateText"]}</p>
            </div>

            {modalFlag && (
                <div id="screen3-modal">
                    <div className="modal-column">
                        <div className="full-center">
                            <div>
                                <h2 className="header2">
                                    {getTranslateText(
                                        "You have not taken the Front View properly"
                                    )}
                                </h2>
                                <strong>{getTranslateText("Problems identified:")}</strong>
                                <ol>
                                    {data.feedbacks.map((warning) => (
                                        <li key={warning}>{warning}</li>
                                    ))}
                                </ol>
                                <p>
                                    {getTranslateText(
                                        "Would you like to reshoot from front or continue as it is?"
                                    )}
                                </p>
                                <div className="modal-btn-flex">
                                    <Button text="Reshoot" onclick={reShoot} />
                                    <Button
                                        text={getTranslateText("Continue")}
                                        translucent={true}
                                        onclick={continueShoot}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-column">
                        <div className="full-center">
                            <div>
                                <canvas ref={canvas2} width="200" height="200"></canvas>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* VIN START */}
            <div className="vinDiv" ref={vinGuidePopup}>
                <div className="vinInnerDiv">
                    <div className="divHead">
                        <h3>{getTranslateText("Stand in front of the VIN before starting capture")}</h3>
                    </div>
                    <div className="divBody">
                        <div className="indicateImage">
                            <div
                                className="indicateImagediv"
                                style={
                                    !vinPosition === "engineVin"
                                        ? { border: "0px solid #006cc9" }
                                        : {}
                                }
                            >
                                <img
                                    src={
                                        vinPosition === "engineVin"
                                            ? engineVin
                                            : vinPosition === "windshieldVin"
                                                ? windshieldVin
                                                : vinPosition === "rightFrontDoorVin"
                                                    ? rightFrontDoorVin
                                                    : vinPosition === "underbodyRightFrontWheelVin" &&
                                                    underbodyRightFrontWheelVin
                                    }
                                />
                            </div>
                            {vinPosition === "engineVin" ? (
                                <div>
                                    <h4>
                                        {getTranslateText("Engine Compartment under the hood")}
                                    </h4>
                                    <p>
                                        {getTranslateText(
                                            "VIN plate is located inside the wall of the hood, visible on opening the hood."
                                        )}
                                    </p>
                                </div>
                            ) : vinPosition === "windshieldVin" ? (
                                <div>
                                    <h4>
                                        {getTranslateText("Bottom Right or Left of Windshield")}
                                    </h4>
                                    <p>
                                        {getTranslateText(
                                            "Most modern vehicles will have VIN at this location."
                                        )}
                                    </p>
                                </div>
                            ) : vinPosition === "rightFrontDoorVin" ? (
                                <div>
                                    <h4>{getTranslateText("Right Side Front Door Frame")}</h4>
                                    <p>
                                        {getTranslateText("Open the door to see the VIN sticker.")}
                                    </p>
                                </div>
                            ) : (
                                vinPosition === "underbodyRightFrontWheelVin" && (
                                    <div>
                                        <h4>
                                            {getTranslateText("Underbody behind Right Front Wheel")}
                                        </h4>
                                        <p>
                                            {getTranslateText(
                                                "Turn the wheel to the right to check this location. This is for older vehicles."
                                            )}
                                        </p>
                                    </div>
                                )
                            )}
                        </div>
                        <div
                            className="markLine"
                            style={
                                vinPosition === "engineVin"
                                    ? {
                                        zIndex: 1,
                                        width: "42%",
                                        height: "3px",
                                        top: "54px",
                                        left: "123px",
                                    }
                                    : vinPosition === "windshieldVin"
                                        ? {
                                            zIndex: 1,
                                            width: "58%",
                                            height: "3px",
                                            top: "54px",
                                            left: "123px",
                                        }
                                        : vinPosition === "rightFrontDoorVin"
                                            ? {
                                                zIndex: 1,
                                                width: "69%",
                                                height: "3px",
                                                top: "54px",
                                                left: "123px",
                                            }
                                            : vinPosition === "underbodyRightFrontWheelVin" ? {
                                                zIndex: 1,
                                                width: "58%",
                                                height: "3px",
                                                top: "54px",
                                                left: "123px",
                                            } : {}
                            }
                        ></div>
                        <div
                            className="markLine"
                            style={
                                vinPosition === "engineVin"
                                    ? {
                                        zIndex: 1,
                                        width: "3px",
                                        height: "17%",
                                        top: "54px",
                                        left: "407px",
                                    }
                                    : vinPosition === "windshieldVin"
                                        ? {
                                            zIndex: 1,
                                            width: "3px",
                                            height: "6%",
                                            top: "54px",
                                            left: "516px",
                                        }
                                        : vinPosition === "rightFrontDoorVin"
                                            ? {
                                                zIndex: 1,
                                                width: "3px",
                                                height: "13%",
                                                top: "56px",
                                                left: "591px",
                                            }
                                            : vinPosition === "underbodyRightFrontWheelVin" ? {
                                                zIndex: 1,
                                                width: "3px",
                                                height: "16%",
                                                top: "56px",
                                                left: "516px",
                                            } : {}
                            }
                        ></div>
                        <div
                            className="markLine"
                            style={
                                vinPosition === "engineVin"
                                    ? {
                                        zIndex: 1,
                                        width: "15px",
                                        height: "15px",
                                        top: "92px",
                                        left: "401px",
                                        borderRadius: "50%",
                                        backgroundColor: "#FFB800",
                                    }
                                    : vinPosition === "windshieldVin"
                                        ? {
                                            zIndex: 1,
                                            width: "15px",
                                            height: "15px",
                                            top: "66px",
                                            left: "510px",
                                            borderRadius: "50%",
                                            backgroundColor: "#FFB800",
                                        }
                                        : vinPosition === "rightFrontDoorVin"
                                            ? {
                                                zIndex: 1,
                                                width: "15px",
                                                height: "15px",
                                                top: "94px",
                                                left: "585px",
                                                borderRadius: "50%",
                                                backgroundColor: "#FFB800",
                                            }
                                            : vinPosition === "underbodyRightFrontWheelVin" ? {
                                                zIndex: 1,
                                                width: "15px",
                                                height: "15px",
                                                top: "102px",
                                                left: "510px",
                                                borderRadius: "50%",
                                                backgroundColor: "#FFB800",
                                            } : {}
                            }
                        ></div>
                        <img className="vinCarImage" src={vinLocationCar} />
                        <button
                            className="vinPopupButton"
                            style={{ width: "25dvw" }}
                            onClick={() => {
                                vinGuidePopup.current.style.display = "none";
                                setShowManualCapture(true);
                                vinDetecting.current.style.display = "block";
                                lowerMessagePopup.current.style.display = "flex";
                            }}
                        >
                            {getTranslateText("I’m ready to capture")}
                        </button>
                    </div>
                </div>
            </div>

            <img ref={leftArrowVin} className="ArrowVin" src={leftVinArrow} />
            <img ref={rightArrowVin} className="ArrowVin" src={RightVInArrow} />

            <div ref={lowerMessagePopup} className="lowerMessagePopup">
                <div className="lowerMessagePopupdiv1">
                    <p>{getTranslateText("Place the VIN inside the white-bordered box")}</p>
                </div>
                {/* <div className="lowerMessagePopupdiv2">
                    <p ref={lowerMessagePopupP2}></p>
                </div> */}
            </div>

            <div ref={dotCod} className="cord">
                <div className="cordDivImage">
                    <img
                        src={
                            vinPosition === "engineVin"
                                ? engineVin
                                : vinPosition === "windshieldVin"
                                    ? windshieldVin
                                    : vinPosition === "rightFrontDoorVin"
                                        ? rightFrontDoorVin
                                        : vinPosition === "underbodyRightFrontWheelVin" &&
                                        underbodyRightFrontWheelVin
                        }
                    />
                </div>
                <div className="cordLine"></div>
                <div className="cordCircle"></div>
            </div>

            <div ref={askUserPopup} className="askUserPopup">
                <div>
                    <p>{getTranslateText("If you find the VIN, then capture it.")}</p>
                    <button
                        onClick={() => {
                            stopGuidingUser = "detectVin";
                            intervalVin = setInterval(() => {
                                startCapturingVin();
                            }, 1000);
                            timeoutVin = setTimeout(() => {
                                clearInterval(intervalVin);
                                stopGuidingUser = "retryPopup";
                                if (retryPopupVin.current)
                                    retryPopupVin.current.style.display = "flex";
                            }, 10000);
                        }}
                    >
                        {getTranslateText("Capture")}
                    </button>
                </div>
                <div>
                    <p>
                        {getTranslateText("If you cannot find the VIN, then continue.")}
                    </p>
                    <button
                        onClick={() => {
                            setAvailableVinLocations((prev) => prev.filter((vin) => vin !== vinPosition));
                            console.log(
                                "vinPosition",
                                vinPosition,
                                "availableVinLocations updated"
                            );
                            readGuide = false;
                            setEnableVInCanvas(false);
                            stopGuidingUser = "differentLocation";
                            askUserPopup.current.style.display = "none";
                            vinModalContainer.current.style.display = "flex";
                            vinModalContainerHeaderRef.current.innerHTML = getTranslateText("Couldn’t detect the VIN. Choose another location");
                        }}
                    >
                        {getTranslateText("Continue")}
                    </button>
                </div>
            </div>

            <div ref={vinModalContainer} className="vinModalContainer">
                <div className="vinModalSubContainer" style={{ width: "90dvw" }}>
                    {availableVinLocations.length === 0 ? (
                        <>
                            <p className="vinModalHeader">
                                {getTranslateText(
                                    "Sorry, but we have tried to find the VIN in all possible positions. You can now exit this process."
                                )}
                            </p>
                            <button
                                onClick={() => {
                                    startVideoRecordingMode();
                                }}
                                className="vinModalButton"
                            >
                                {getTranslateText("Continue")}
                            </button>
                        </>
                    ) : (
                        <>
                            <p ref={vinModalContainerHeaderRef} className="vinModalHeader" style={{ margin: "0px" }}></p>
                            <div className="vinTypeContainer">
                                {availableVinLocations.map((e) => (
                                    <div
                                        className="vinModalSquare"
                                        onClick={() => {
                                            setVinPosition(e);
                                            vinGuidePopup.current.style.display = "flex";
                                            vinModalContainer.current.style.display = "none";
                                        }}
                                        key={e} // Adding a unique key to avoid React warnings
                                    >
                                        <img
                                            className="vinModalMainImage"
                                            src={
                                                e === "windshieldVin"
                                                    ? windshieldVin
                                                    : e === "rightFrontDoorVin"
                                                        ? rightFrontDoorVin
                                                        : e === "engineVin"
                                                            ? engineVin
                                                            : e === "underbodyRightFrontWheelVin"
                                                                ? underbodyRightFrontWheelVin
                                                                : ""
                                            }
                                            alt="123"
                                        />
                                        <p className="vinModalSubHeader">
                                            {e === "windshieldVin"
                                                ? "Windshield"
                                                : e === "rightFrontDoorVin"
                                                    ? "Door Frame"
                                                    : e === "engineVin"
                                                        ? "Engine Compartment"
                                                        : e === "underbodyRightFrontWheelVin"
                                                            ? "Underbody Front Wheel"
                                                            : ""}
                                        </p>
                                        <img className="vinModalArrow" src={vinArrow} alt="123" />
                                    </div>
                                ))}
                            </div>
                        </>
                    )}
                </div>
            </div>

            <div
                ref={vinDetecting}
                style={
                    vinDetected
                        ? { border: "3px solid rgb(5, 220, 81)" }
                        : { border: "3px solid #ffff" }
                }
                className="vinDetecting"
            ></div>

            <div ref={retryPopupVin} className="retryPopupVin">
                <p>{getTranslateText("VIN not detected please retry capturing")}</p>
                <button
                    onClick={() => {
                        stopGuidingUser = "detectVin";
                        retryPopupVin.current.style.display = "none";
                        intervalVin = setInterval(() => {
                            startCapturingVin();
                        }, 1000);
                        timeoutVin = setTimeout(() => {
                            clearInterval(intervalVin);
                            stopGuidingUser = "retryPopup";
                            if (retryPopupVin.current)
                                retryPopupVin.current.style.display = "flex";
                        }, 10000);
                    }}
                >
                    {getTranslateText("Retry")}
                </button>
                <p>{getTranslateText("If you want to end the process")}</p>
                <button
                    onClick={() => {
                        retryPopupVin.current.style.display = "none";
                        startVideoRecordingMode();
                    }}
                >
                    {getTranslateText("Continue")}
                </button>
            </div>

            <div id="display-card-success-top" ref={feedbackSuccessTopPopRef} style={{ display: "none" }}>
                <div className="success-section">
                    <div className="success-icon-wrapper">
                        <Check className="success-icon" strokeWidth={3} />
                    </div>
                    <div className="success-text-wrapper">
                        <h1 className="success-title">
                            {
                                getTranslateText("# Detected Successfully!").replace("#", currentBlock && currentBlock["id"] ? currentBlock["id"] : "VIN")
                            }
                        </h1>
                        {
                            Object.keys(config).includes("allowVinFeedbackEdit") && config["allowVinFeedbackEdit"] && <p className="success-subtitle">
                                {getTranslateText("Please verify the information detected below.")}
                            </p>
                        }
                    </div>
                </div>
            </div>
            <div ref={feedBackPopUp} id="display-card-zizo" style={{ display: "none" }}>
                <div ref={headerText1} id="zizo-loader-text" style={{ textAlign: "center", display: "block", padding: "5dvh 1dvh 5dvh 1dvh" }}>
                    <h3 style={{ margin: "0px" }} ref={feedBackPopText}></h3>
                </div>
                <div
                    ref={imageRef}
                    id="zizo-loader"
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <img ref={carInspectionRef} src={car_inspection} alt="123" style={{ zIndex: 5, width: "17dvw", height: "unset", borderRadius: "2%", padding: "0px 0px 2dvh 0px" }} />
                </div>
                <div ref={feedbackBtnRef} style={{ display: "none", padding: "0px 0px 2dvh 0px", width: "100%", alignContent: "center", justifyContent: "center" }}>
                    <div style={{ display: "flex", flexDirection: "row", gap: "10px", width: "95%", justifyContent: "center" }}>
                        {availableVinLocations.length > 1 && (
                            <button
                                style={{ flex: 1, padding: "10px 5px", backgroundColor: config["colors"] && config["colors"]["btn"] ? config["colors"]["btn"] : "#006cc9", color: "white", border: "none", borderRadius: "8px", fontWeight: "bold", fontSize: "14px" }}
                                onClick={() => {
                                    if (feedBackPopUp.current) feedBackPopUp.current.style.display = "none";
                                    if (backRef.current) backRef.current.style.display = "block";
                                    setAvailableVinLocations(prev => prev.filter(v => v !== vinPosition));
                                    if (vinModalContainer.current) vinModalContainer.current.style.display = "flex";
                                    if (vinModalContainerHeaderRef.current) vinModalContainerHeaderRef.current.innerHTML = getTranslateText("Couldn’t detect the VIN. Choose another location");
                                }}
                            >
                                {getTranslateText("Choose another VIN location")}
                            </button>
                        )}
                        <button
                            style={{ flex: 1, padding: "10px 5px", backgroundColor: "white", color: config["colors"] && config["colors"]["btn"] ? config["colors"]["btn"] : "#006cc9", border: `2px solid ${config["colors"] && config["colors"]["btn"] ? config["colors"]["btn"] : "#006cc9"}`, borderRadius: "8px", fontWeight: "bold", fontSize: "14px" }}
                            onClick={() => {
                                if (feedBackPopUp.current) feedBackPopUp.current.style.display = "none";
                                if (backRef.current) backRef.current.style.display = "block";
                                setSkipLambdaNextTime(true);
                                setShowManualCapture(true);
                                if (vinDetecting.current) vinDetecting.current.style.display = "block";
                                if (lowerMessagePopup.current) lowerMessagePopup.current.style.display = "flex";
                            }}
                        >
                            {getTranslateText("Recapture here")}
                        </button>
                    </div>
                </div>
            </div>
            <div id="display-card-success-bottom" ref={feedbackSuccessBottomPopRef} style={{ display: "none" }}>
                {/* --- 2. VIN Display/Edit Section --- */}
                <div id="vin-edit-section">
                    <label style={{ color: "#ffffffde", fontSize: '13px', fontWeight: '600', margin: "0px", padding: "5px 0px 5px 5px" }}>{getTranslateText("Detected #:").replace("#", currentBlock && currentBlock["id"] ? currentBlock["id"] : "VIN")}</label>

                    {isEditing ? (
                        <>
                            <input
                                type="text"
                                value={message}
                                onChange={handleVinChange}
                                onBlur={() => {
                                    setMessage(formatVinForDisplay(message));
                                    setIsEditing(false);
                                    if (vinEditToastId) {
                                        toast.dismiss(vinEditToastId); // Dismiss any lingering toast
                                        vinEditToastId = null;
                                    }
                                }}
                                autoFocus
                                id="vin-input"
                                ref={vinInputRef}
                            />
                        </>
                    ) : (
                        <div style={{ width: '100%', textAlign: 'left', paddingLeft: "5px" }}>
                            <span style={{ fontSize: '24px', fontWeight: '800', color: 'white', letterSpacing: '1px' }}>{formatVinForDisplay(message)}</span>
                        </div>
                    )}
                    {
                        Object.keys(config).includes("allowVinFeedbackEdit") && config["allowVinFeedbackEdit"] &&
                        <>
                            <div style={{ position: 'absolute', top: '12px', right: '12px', width: "5dvw", height: "6dvh" }}>
                                <div onClick={() => setIsEditing(true)} className="icon-btn">
                                    <img src="https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/edit-icon.png" alt="123" style={{ width: "3.5dvw", objectFit: "unset", height: "unset" }} />
                                </div>
                            </div>
                            <div className="input-footer">
                                <span className="input-status">
                                    {isEditing ? getTranslateText("Editing enabled") : getTranslateText("Tap edit icon to modify")}
                                </span>
                            </div>
                        </>
                    }
                </div>
                {
                    Object.keys(config).includes("allowVinFeedbackEdit") && config["allowVinFeedbackEdit"] &&
                    <div style={{ display: "flex", padding: "0px 0px 2dvh 0px", alignContent: "center", justifyContent: "center", width: "180px", borderRadius: "5px" }}>
                        <button
                            className="feedbackbtn"
                            style={{ backgroundColor: config && config["colors"] ? config["colors"]["btn"] : "#006cc9", fontSize: "medium" }}
                            onClick={() => {
                                if (message.length < 17) {
                                    toast.error(getTranslateText("# must be 17 characters long.").replace("#", currentBlock && currentBlock["id"] ? currentBlock["id"] : "VIN"), {
                                        theme: "colored",
                                    });
                                    return;
                                }
                                if (feedbackSuccessTopPopRef.current) feedbackSuccessTopPopRef.current.style.display = "none";
                                if (feedbackSuccessBottomPopRef.current) feedbackSuccessBottomPopRef.current.style.display = "none";
                                if (backRef.current) backRef.current.style.display = "block";
                                imageNext();
                            }}
                        >
                            {feedbackBtnText}
                        </button>
                    </div>
                }
            </div>
            {/* VIN END  */}

            {showOdometerCapture && (
                <div
                    className="redLineVINcontainerView"
                    style={{
                        height: ["porto_seguros"].includes(clientId) ? "90dvh" : "100dvh",
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        zIndex: 9999,
                        pointerEvents: "auto",
                        backgroundColor: "transparent",
                        display: "flex"
                    }}
                >
                    <div
                        className="redLineVIN"
                        style={{
                            width: "70vw",
                            height: ["porto_seguros"].includes(clientId) ? "47vh" : "70vh"
                        }}
                    ></div>
                    <div ref={lowerMessagePopup} className="lowerMessagePopup" style={{ display: "flex" }}>
                        <div className="lowerMessagePopupdiv1">
                            <p>{getTranslateText("Place the Odometer inside the white-bordered box")}</p>
                        </div>
                    </div>

                    <div
                        style={{
                            backgroundImage: `url(${cameraImg})`,
                            backgroundSize: "37px 37px",
                            backgroundRepeat: "no-repeat",
                            objectFit: "cover",
                            backgroundPosition: "center",
                            display: "block",
                            zIndex: 20
                        }}
                        onClick={captureOdometerImg}
                        id="btn-vin-start"
                    ></div>
                </div>
            )}
        </div>
    );
};

export default IntegratedVideo;
